import {addQuantityUpdating, setNewProducts, useProductsDispatch, useProductsState} from "../ProductsContext";
import {
  Backdrop, Box, Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText, Menu, MenuItem, Select, Tooltip,
  TextField,
} from "@mui/material";
import React, {Fragment, useEffect, useMemo, useState} from "react";
import axios from "axios";
import cookie from "react-cookies";
import {
  ETC_SEPARATOR, HISTORY_TYPE_COUPANG_CENTER_CHANGED, HISTORY_TYPE_NAVER_CENTER_CHANGED,
  HISTORY_TYPE_COUPANG_RELEASE,
  HISTORY_TYPE_EDIT,
  HISTORY_TYPE_EDIT_CENTER, HISTORY_TYPE_EDIT_COUPANG, HISTORY_TYPE_EDIT_NAVER,
  HISTORY_TYPE_EDIT_OUT,
  HISTORY_TYPE_GSHEET_EDIT,
  HISTORY_TYPE_NAVER_RELEASE,
  HISTORY_TYPE_RECV,
  HISTORY_TYPE_STORE_FIX, MOBILE_WIDTH_THRESHOLD,
  RECEIVER_COOKIE_KEY, EXPIRE_DATE_MAX_YEAR
} from "../constant";
import { FixedSizeList } from 'react-window';
import useWindowDimensions from "../Dimension";
import {Error, ErrorOutline, FilterList} from "@mui/icons-material";
import moment from "moment";
import {useHistory} from "react-router-dom";
import {FSBarcodeReader} from "./FSBarcodeReader";
import {
  changeImageURL,
  changeStockValue, getCenterStock,
  getCleanStockValue, getExpireDate,
  getHistoryValues, getRackCodeByCenterId, getRecentExpireDate, getRecvCenterName,
  getValidString, getWarehouseCenterIdFromCode,
  getWarehouseName, getWarehouseNameFromId, getWarehouseRackCode
} from "../stringutils";
import useScrollbarSize from "react-scrollbar-size";
import {useSnackbar} from "notistack";
import {useWarehouseState} from "../WarehouseContext";

const EDIT_TYPE_RACK_CODE = 0
const EDIT_TYPE_STOCK_COMMENT = 1
const EDIT_TYPE_CENTER_STOCK = 2
const EDIT_TYPE_PRODUCT_INFO = 3

const ROW_HEIGHT = 54
const TOTAL_COLUMNS = 23
const RACKCODE_SX = 2.8
const COMMENT_SX = 3
const WAREHOUSE_SX = 3.2

const STOCK_HISTORY_ROW_HEIGHT = 54
const HISTORY_HEIGHT = 240


const rowItemClickableFullWidth = {
  cursor : 'pointer',
  display : 'flex',
  flex : 1,
  alignItems : 'center',
};
const rowItemClickable = {
  cursor : 'pointer',
  display : 'flex',
  alignItems : 'center',
};

const cell_first = {
  display : "flex",
  paddingLeft : (theme) => theme.spacing(2),
  paddingRight : (theme) => theme.spacing(1),
  alignItems : "center"
};

const cell = {
    display : "flex",
    paddingTop : (theme) => theme.spacing(1),
    paddingBottom : (theme) => theme.spacing(1),
    paddingLeft : (theme) => theme.spacing(2),
    paddingRight : (theme) => theme.spacing(1),
    borderLeftWidth : 0.5,
    borderLeftColor : 'lightgrey',
    borderLeftStyle : 'solid',
    alignItems : "center"
};

const cellRows = {
  ...cell,
  height : ROW_HEIGHT
}

const centerHistoryIcon = {
  paddingTop : 16,
  paddingBottom : 16,
  cursor : 'pointer',
  display : 'flex',
  alignItems : 'center',
};

export default function ProductManage(props) {
  const history = useHistory()
  // const styles = useStyles()
  const warehouseState = useWarehouseState()

  const { windowHeight, windowWidth } = useWindowDimensions();
  const { height, width } = useScrollbarSize();
  const productState = useProductsState()
  const productsDispatch = useProductsDispatch()
  const [requesting, setRequesting] = useState(false)
  const [products, setProducts] = useState([])
  const [editDialog, setEditDialog] = useState({
    open : false,
    type : -1,
    index : -1,
    center_id : -1,
    product : null,
    newData : '',
    newData2 : '',
    history : [],
    originalData : '',
    req_type: '',
    etc_reason: '',
  })

  const [storeBalanceFilter, setStoreBalanceFilter] = useState(new Set())

  const [centerIDForStoreBalance, setCenterIDForStoreBalance] = useState(null)

  const [storeBalanceDialog, setStoreBalanceDialog] = useState({
    open : false,
    product : null,
    index : -1,
    center_id : -1,
    store : -1,
  })

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [imageShow, setImageShow] = useState({
    open : false,
    url : '',
    title : ''
  })

  const [popover, setPopover] = useState({
    open : false,
    anchorEl : null,
    message : ''
  })

  const [dialog, setDialog] = useState({
    open : false,
    title : '',
    message : '',
    sub_messages : [],
  })

  const [applyStockCommentFilter, setApplyStockCommentFilter] = useState(false)

  const [stockCountFilter, setStockCountFilter] = useState(new Set())

  const [centerCode, setCenterCode] = useState('ALL')
  // const [centerMenuAnchor, setCenterMenuAnchor] = useState(null)

  const [expireDateFilter, setExpireDateFilter] = useState(null)

  const [expireDateDialog, setExpireDateDialog] = useState({
    open: false,
    years : [],
    index : -1,
    product : null,
    centerId : null,
    history : [],
    expireDateList: [],
    listLoading: false,
  })

  const isApplyingFilter = () => {
    return centerIDForStoreBalance != null || applyStockCommentFilter || centerCode !== 'ALL' || expireDateFilter != null
  }

  const showStockEditDialog = (stock, product, index) => {
    setRequesting(true)

    axios.get(`${process.env.REACT_APP_API_HOST}/product/stock_info`, {
      params : {
        token : cookie.load(RECEIVER_COOKIE_KEY),
        id_fs : product.id_fs,
        center_id : stock.center_id,
      },
      timeout : 15000,
    }).then(resp => {
      console.log('stock_info ', resp)
      if(resp.status === 200 && resp.data != null && resp.data['code'] === 200) {

        stock.naver_stock = resp.data.results.naver_stock
        stock.coupang_stock = resp.data.results.coupang_stock
        stock.out_stock = resp.data.results.out_stock
        stock.center_stock = resp.data.results.center_stock
        // Parse naver_stock_detail for tooltip display
        let naverStockDetail = []
        try {
          const detailRaw = resp.data.results.naver_stock_detail
          if (detailRaw) {
            // detail may come as a stringified JSON array
            naverStockDetail = typeof detailRaw === 'string' ? JSON.parse(detailRaw) : detailRaw
          }
        } catch (e) {
          console.warn('Failed to parse naver_stock_detail', e)
        }

        axios.get(`${process.env.REACT_APP_API_HOST}/product/center_stock_history`, {
          params : {
            token : cookie.load(RECEIVER_COOKIE_KEY),
            id_fs : product.id_fs,
            center_id : stock.center_id,
          },
          timeout : 15000,
        }).then(resp => {
          console.log(resp)
          if(resp.status === 200 && resp.data != null && resp.data['code'] === 200) {

            let naver_stock = changeStockValue(stock.naver_stock)
            let coupang_stock = changeStockValue(stock.coupang_stock)
            let out_stock = changeStockValue(stock.out_stock)
            let center_stock = changeStockValue(stock.center_stock)
            let results = [
              {
                curr : true,
                naver_stock : naver_stock,
                coupang_stock : coupang_stock,
                out_stock : out_stock,
                center_stock : center_stock,
                naver_stock_detail: Array.isArray(naverStockDetail) ? naverStockDetail : [],
              },
              ...resp.data.results
            ]
            const originalValue = getCenterStock(stock)
            setEditDialog({
              type : EDIT_TYPE_CENTER_STOCK,
              open : true,
              index : index,
              product : product,
              center_id: stock.center_id,
              newData : originalValue,
              originalData : originalValue,
              // history : resp.data.results ? resp.data.results : [],
              history : results,
              req_type: '',
              etc_reason: '',
            })
          }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
            history.replace('/signin')
          }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 499){
            cookie.remove(RECEIVER_COOKIE_KEY)
            history.replace('/not-permitted')
          }else{
             // setSnackbar({
             //  open : true,
             //  message : '변경 이력을 가져오는데 실패했습니다.',
             //  })
            enqueueSnackbar("변경 이력을 가져오는데 실패했습니다.", {variant : 'error'})
          }
        }).catch((error) => {
          console.log('error', error)
          // setSnackbar({
          //   open : true,
          //   message : '변경 이력을 가져오는데 실패했습니다.',
          // })
          enqueueSnackbar("변경 이력을 가져오는데 실패했습니다.", {variant : 'error'})
        }).finally(() => {
          setRequesting(false)
        })

      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
        history.replace('/signin')
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 499){
        cookie.remove(RECEIVER_COOKIE_KEY)
        history.replace('/not-permitted')
      }else{
         // setSnackbar({
         //  open : true,
         //  message : '변경 이력을 가져오는데 실패했습니다.',
         //  })
        enqueueSnackbar("변경 이력을 가져오는데 실패했습니다.", {variant : 'error'})
        setRequesting(false)
      }
    }).catch((error) => {
      console.log('error', error)
      // setSnackbar({
      //   open : true,
      //   message : '변경 이력을 가져오는데 실패했습니다.',
      // })
      enqueueSnackbar("변경 이력을 가져오는데 실패했습니다.", {variant : 'error'})
      setRequesting(false)
    }).finally(() => {

    })

  }

  const updateGsheetRackCode = (index, id_fs, new_gsheetRackCode) => {
    const newProducts = [...products]
    newProducts[index].gsheet_rack_code = new_gsheetRackCode

    if((props.products && props.products.length > 0) || isApplyingFilter()) {
      setProducts(newProducts)
      for(let p of productState.data) {
        if(p.id_fs === id_fs) {
          p.gsheet_rack_code = new_gsheetRackCode
          break
        }
      }
    }else{
      setNewProducts(productsDispatch, newProducts)
    }
  }

  const updateExpireDate = (index, id_fs, centerId, newExpireDate) => {
    // console.log('updateExpireDate ', index, id_fs, newExpireDate, moment(newExpireDate).format('YYYY-MM-DD 00:00:00'))
    const newProducts = [...products]
    // newProducts[index].expire_dates = moment(newExpireDate).format('YYYY-MM-DD 00:00:00')
    console.log(newProducts[index])
    const expireDateString = moment(newExpireDate).format('YYYY-MM-DD 00:00:00')
    for(let stock of newProducts[index].stocks){
      console.log(stock)
      if(stock.center_id === centerId){
        if(stock.expire_dates == null || stock.expire_dates === ''){
          stock.expire_dates = expireDateString
        }else{
          let expire_dates = stock.expire_dates.split(',')
          let new_expire_dates = expire_dates.filter((date) => date > expireDateString)
          stock.expire_dates = [expireDateString, ...new_expire_dates].join(',')
        }

      }
    }
    console.log(newProducts[index])
    if((props.products && props.products.length > 0) || isApplyingFilter()) {
      setProducts(newProducts)
      for(let p of productState.data) {
        if(p.id_fs === id_fs) {
          p.stocks = newProducts[index].stocks
        }
      }
    }else{
      console.log('updateExpireDate (setNewPRoducts) ', index, id_fs, newExpireDate)
      setNewProducts(productsDispatch, newProducts)
    }
  }

  const getExpireDateHistory = (index, product, centerId) => {
    setRequesting(true)

    axios.get(`${process.env.REACT_APP_API_HOST}/product/expire_date_history`, {
      params : {
        token : cookie.load(RECEIVER_COOKIE_KEY),
        id_fs : product.id_fs,
        center_id : centerId,
      },
      timeout : 15000,
    }).then(resp => {
      console.log(resp)
      if(resp.status === 200 && resp.data != null && resp.data['code'] === 200) {

        showExpireDateDialog(index, product, centerId, resp.data.results)
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
        history.replace('/signin')
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 499){
        cookie.remove(RECEIVER_COOKIE_KEY)
        history.replace('/not-permitted')
      }else{
        enqueueSnackbar("변경 이력을 가져오는데 실패했습니다.", {variant : 'error'})
      }
    }).catch((error) => {
      console.log('error', error)
      enqueueSnackbar("변경 이력을 가져오는데 실패했습니다.", {variant : 'error'})
      setRequesting(false)
    }).finally(() => {
      setRequesting(false)

    })
 }
  const getRackCodeAndShowHistory = (product, index) => {
    axios.get(`${process.env.REACT_APP_API_HOST}/product/gsheet_rack_code`, {
      params : {
        token : cookie.load(RECEIVER_COOKIE_KEY),
        id_fs : product.id_fs,
      },
      timeout : 15000,
    }).then(resp => {
      console.log(resp)
      if(resp.status === 200 && resp.data != null && resp.data['code'] === 200) {
        if(resp.data.results){
          updateGsheetRackCode(index, product.id_fs, resp.data.results.gsheet_rack_code)
        }
        showRackCodeDialog(product, index)
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
        history.replace('/signin')
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 499){
        cookie.remove(RECEIVER_COOKIE_KEY)
        history.replace('/not-permitted')
      }else{
        enqueueSnackbar("변경 이력을 가져오는데 실패했습니다.", {variant : 'error'})
      }
    }).catch((error) => {
      console.log('error', error)
      enqueueSnackbar("변경 이력을 가져오는데 실패했습니다.", {variant : 'error'})
      setRequesting(false)
    }).finally(() => {

    })
 }

 const showRackCodeDialog = (product, index) => {
    setRequesting(true)
    axios.get(`${process.env.REACT_APP_API_HOST}/product/rack_code_history`, {
      params : {
        token : cookie.load(RECEIVER_COOKIE_KEY),
        id_fs : product.id_fs,
      },
      timeout : 15000,
    }).then(resp => {
      console.log(resp)
      if(resp.status === 200 && resp.data != null && resp.data['code'] === 200) {
        setEditDialog({
          type : EDIT_TYPE_RACK_CODE,
          open : true,
          index : index,
          product : product,
          center_id: -1,
          newData : product.gsheet_rack_code,
          history : resp.data.results ? resp.data.results : [],
        })

      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
        history.replace('/signin')
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 499){
        cookie.remove(RECEIVER_COOKIE_KEY)
        history.replace('/not-permitted')
      }else{

        enqueueSnackbar("변경 이력을 가져오는데 실패했습니다.", {variant : 'error'})
      }
    }).catch((error) => {
      console.log('error', error)
      enqueueSnackbar("변경 이력을 가져오는데 실패했습니다.", {variant : 'error'})
    }).finally(() => {
      setRequesting(false)
    })
  }

  const updateStockComment = (index, id_fs, new_stockComment) => {
    const newProducts = [...products]
    newProducts[index].stock_comment = new_stockComment
    if((props.products && props.products.length > 0) || isApplyingFilter()) {

      setProducts(newProducts)
      for(let p of productState.data) {
        if(p.id_fs === id_fs) {
          p.stock_comment = new_stockComment
          break
        }
      }
    }else{
      setNewProducts(productsDispatch, newProducts)
    }
  }

  const getStockCommentAndShowHistory = (product, index) => {
    axios.get(`${process.env.REACT_APP_API_HOST}/product/stock_comment`, {
      params : {
        token : cookie.load(RECEIVER_COOKIE_KEY),
        id_fs : product.id_fs,
      },
      timeout : 15000,
    }).then(resp => {
      console.log(resp)
      if(resp.status === 200 && resp.data != null && resp.data['code'] === 200) {
        if(resp.data.results){
          updateStockComment(index, product.id_fs, resp.data.results.stock_comment)
        }
        showStockCommentDialog(product, index)
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
        history.replace('/signin')
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 499){
        cookie.remove(RECEIVER_COOKIE_KEY)
        history.replace('/not-permitted')
      }else{
        enqueueSnackbar("변경 이력을 가져오는데 실패했습니다.", {variant : 'error'})
      }
    }).catch((error) => {
      console.log('error', error)
      enqueueSnackbar("변경 이력을 가져오는데 실패했습니다.", {variant : 'error'})
      setRequesting(false)
    }).finally(() => {

    })
 }

 const showStockCommentDialog = (product, index) => {
    setRequesting(true)
    axios.get(`${process.env.REACT_APP_API_HOST}/product/stock_comment_history`, {
      params : {
        token : cookie.load(RECEIVER_COOKIE_KEY),
        id_fs : product.id_fs,
      },
      timeout : 15000,
    }).then(resp => {
      console.log(resp)
      if(resp.status === 200 && resp.data != null && resp.data['code'] === 200) {
          setEditDialog({
            type : EDIT_TYPE_STOCK_COMMENT,
            open : true,
            index : index,
            product : product,
            newData : product.stock_comment,
            history : resp.data.results ? resp.data.results : [],
          })
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
        history.replace('/signin')
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 499){
        cookie.remove(RECEIVER_COOKIE_KEY)
        history.replace('/not-permitted')
      }else{

        enqueueSnackbar("변경 이력을 가져오는데 실패했습니다.", {variant : 'error'})
      }
    }).catch((error) => {
      console.log('error', error)

      enqueueSnackbar("변경 이력을 가져오는데 실패했습니다.", {variant : 'error'})
    }).finally(() => {
      setRequesting(false)
    })
  }

  const updateProductInfo = (index, id_fs, id, opt_code) =>{
    const newProducts = [...products]
    newProducts[index].id = id
    newProducts[index].opt_code = opt_code
    if ((props.products && props.products.length > 0) || isApplyingFilter()) {
      setProducts(newProducts)
      for (let p of productState.data) {
        if (p.id_fs === id_fs) {
          p.id = id
          p.opt_code = opt_code
          break
        }
      }
    } else {
      setNewProducts(productsDispatch, newProducts)
    }
  }

  const getProductInfoAndShowHistory = (product, index) => {

    setRequesting(true)
    axios.get(`${process.env.REACT_APP_API_HOST}/product/info`, {
     params: {
       token: cookie.load(RECEIVER_COOKIE_KEY),
       id_fs: product.id_fs,
     },
     timeout: 15000,
    }).then(resp => {

     console.log('get info resp ', resp)
     if (resp.status === 200 && resp.data != null && resp.data['code'] === 200) {
        if(resp.data.results){
          updateProductInfo(index, product.id_fs, resp.data.results.id, resp.data.results.opt_code)
        }
        showProductInfoHistory(product, index)
     } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
       history.replace('/signin')
     } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 499) {
       cookie.remove(RECEIVER_COOKIE_KEY)
       history.replace('/not-permitted')
     } else {
       enqueueSnackbar("변경 이력을 가져오는데 실패했습니다.", {variant: 'error'})
     }

    }).catch((error) => {
     console.log('error', error)
     enqueueSnackbar("변경 이력을 가져오는데 실패했습니다.", {variant: 'error'})
     setRequesting(false)
    })
  }

  const showProductInfoHistory = (product, index) => {
    setRequesting(true)
    axios.get(`${process.env.REACT_APP_API_HOST}/product/info_history`, {
       params: {
         token: cookie.load(RECEIVER_COOKIE_KEY),
         id_fs: product.id_fs,
       },
       timeout: 15000,
    }).then(resp => {

       console.log(resp)
       if (resp.status === 200 && resp.data != null && resp.data['code'] === 200) {
         setEditDialog({
           type: EDIT_TYPE_PRODUCT_INFO,
           open: true,
           index: index,
           product: product,
           newData: product.id,
           newData2: product.opt_code,
           history: resp.data.results ? resp.data.results : [],
         })
       } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
         history.replace('/signin')
       } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 499) {
         cookie.remove(RECEIVER_COOKIE_KEY)
         history.replace('/not-permitted')
       } else {
         enqueueSnackbar("변경 이력을 가져오는데 실패했습니다.", {variant: 'error'})
       }

    }).catch((error) => {
       console.log('error', error)
       enqueueSnackbar("변경 이력을 가져오는데 실패했습니다.", {variant: 'error'})
    }).finally(() => {
      setRequesting(false)
    })


 }





  // const getStock = (center_id, product) => {
  //   // console.log(center_id, product)
  //   switch (center_id) {
  //     case CENTER_ID_SC:
  //       return getCenterStock(product.s_stocks).toString()
  //     case CENTER_ID_YS:
  //       return getCenterStock(product.y_stocks).toString()
  //     default:
  //       return '0'
  //   }
  // }

  const getStoreBalance = (center_id, product) => {

    if(product){
      for(let stock of product.stocks){
        if(stock.center_id === center_id){
          return stock.store_balance;
        }
      }
    }

    return 0;
  }

  const renderCenterStocks = (index, product) => {
    const warehouses = (warehouseState && warehouseState.data && warehouseState.data.results) ? warehouseState.data.results : [];
    return warehouses.map((warehouse) => {
      const stock = (product && product.stocks) ? (product.stocks.find((s) => s.center_id === warehouse.id) || {
        center_id: warehouse.id,
        naver_stock: 0,
        coupang_stock: 0,
        out_stock: 0,
        center_stock: 0,
        store_balance: 0,
        expire_dates: ''
      }) : {
        center_id: warehouse.id,
        naver_stock: 0,
        coupang_stock: 0,
        out_stock: 0,
        center_stock: 0,
        store_balance: 0,
        expire_dates: ''
      };
      let centerStock = getCenterStock(stock);
      const showUpdatingMark = Array.isArray(productState.quantityUpdateIdfs) && productState.quantityUpdateIdfs.includes(product?.id_fs);
      return <Grid
        item
        xs={WAREHOUSE_SX}
        sx={{
          // ...cellRows,
          // backgroundColor : centerStock > 0 ? '#81d4fa' : 'transparent',
          // color : centerStock > 0 ? 'white' : 'grey',
          // fontWeight : 'bold'
        }}
      >
        <Grid container columns={2}>
          <Grid
            item
            xs={1}
            sx={{
              ...cellRows,
              backgroundColor : centerStock > 0 ? '#81d4fa' : 'transparent',
              cursor : 'pointer',
            }}>
            <Box
              sx={{
                paddingRight : (theme) => theme.spacing(0.5),
                paddingTop : 2,
                paddingBottom : 2,
                flexGrow : 1
              }}
              onClick={() => {
                showStockEditDialog(stock, product, index)
              }}
            >
              {centerStock}{showUpdatingMark ? '*' : ''}
            </Box>
            {
              stock.store_balance < 0 ?
                <Box
                  sx={{
                    ...rowItemClickable,
                    paddingLeft : (theme) => theme.spacing(0),
                    paddingTop : 2,
                    paddingBottom : 2,
                    color : 'red',
                    fontWeight : 'bold'
                  }}
                  onClick={() => {
                    setStoreBalanceDialog({
                      open : true,
                      index: index,
                      center_id: stock.center_id,
                      product: product
                    })

                  }}
                >
                  {"(" + stock.store_balance + ")"}
                </Box>
                :
                <div/>
            }
          </Grid>
          <Grid
            item
            xs={1}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection : 'column',
              pl : 1,
              borderLeftWidth : 0.3,
              borderLeftColor : '#B0BEC5',
              borderLeftStyle : 'solid',
              cursor : 'pointer',
              ...expireDateColor(stock, centerStock)
            }}
            onClick={()=>{
              if(centerStock > 0) {
                getExpireDateHistory(index, product, stock.center_id)
              }else {
                enqueueSnackbar(`"재고 개수가 0인 상품은 유통기한을 수정할수 없습니다.`, {variant : 'warning'})
              }

            }}
          >
            {
              centerStock > 0 && stock.expire_dates ?
                stock.expire_dates.split(',').map((d, index)=>
                  <div key={index}>{moment(new Date(d)).format('YYYY/MM')}</div>
                ) : "-"
            }
          </Grid>
        </Grid>
      </Grid>

    })
  }

  const remainExpireMonth = (stock) => {
    if(stock.expire_dates){
      let dates = stock.expire_dates.split(',')
      if(dates && dates.length > 0){
        let now = new Date(new Date().getFullYear(), new Date().getMonth())
        let nowMoment = moment(now)
        let expMoment = moment(dates[0])
        let diff = moment(expMoment).diff(nowMoment, 'months', true)
        // console.log('remainExpireMonth ', nowMoment.format('YY년MM월DD일 HH:mm'), expMoment.format('YY년MM월DD일 HH:mm'), diff)
        return diff
      }
    }

    return 9999

  }

  const expireDateColor = (stock, centerStock) => {
    if(centerStock > 0){
      const diff = remainExpireMonth(stock)
      if(diff <= 6){
        return { backgroundColor : 'red', color : 'white'}
      }else if(diff <= 12){
        return { backgroundColor : '#FF8A80', color : 'white'}
      }
    }

    return { backgroundColor : 'transparent', color : 'black'}
  }

  const expireDateColorByDate = (dateStr) => {
    if(!dateStr){
      return { backgroundColor : 'transparent', color : 'black'}
    }
    try{
      const now = moment(new Date(new Date().getFullYear(), new Date().getMonth()))
      const expMoment = moment(new Date(dateStr))
      const diff = moment(expMoment).diff(now, 'months', true)
      if(diff <= 6){
        return { backgroundColor : 'red', color : 'white'}
      }else if(diff <= 12){
        return { backgroundColor : '#FF8A80', color : 'white'}
      }
    }catch(e){
      // ignore
    }
    return { backgroundColor : 'transparent', color : 'black'}
  }

  const productRow = ({index , style}) => {
    const product = products[index]
    return <div key={index} style={{...style, width : '100%', display : 'flex', flexDirection : 'column'}}>
      <div key={index} style={{fontSize : 14, display : 'flex', height : ROW_HEIGHT, alignItems : 'center'}}>
        <Grid key={index} container component="div" columns={TOTAL_COLUMNS}>
          <Grid
            key={index}
            sx={{...cell_first}}
            item xs={calSxForName()}>
            <div style={{display : 'flex', flex : 1}}>
              {
                product.img_url ?
                  <img
                    onClick={()=>{
                      setImageShow({
                        open: true,
                        url : product.img_url,
                        title : product.name
                      })
                    }}
                    src={changeImageURL(product.img_url)} alt={product.name} style={{...rowItemClickable, width : ROW_HEIGHT - 6, height : ROW_HEIGHT - 6}}/>
                  :
                  <div style={{ width : ROW_HEIGHT - 6, height : ROW_HEIGHT - 6}}/>
              }
              <Box
                onClick={()=>{
                  getProductInfoAndShowHistory(product, index)
                }}
                sx={{
                  ...rowItemClickableFullWidth,
                  ml : (theme) => theme.spacing(1),
                }}>
                {"[" + product.id + " / " + product.opt_code + " / " + product.id_fs + " / " + getValidString(product.naver_center_code) + " / " + getValidString(product.coupang_center_code) +"] " + product.name}
              </Box>
            </div>

          </Grid>
          <Grid
            sx={{...cellRows}}
            item
            xs={RACKCODE_SX}
          >
            <Box
              sx={rowItemClickableFullWidth}
              style={{paddingTop : 16, paddingBottom : 16}}
              onClick={() => {
                getRackCodeAndShowHistory(product, index)
              }}

            >
              {product.gsheet_rack_code || <br></br>}
            </Box>
            {/*<Box*/}
            {/*  sx={{*/}
            {/*    paddingTop : 16,*/}
            {/*    paddingBottom : 16,*/}
            {/*    cursor : 'pointer',*/}
            {/*    display : 'flex',*/}
            {/*    alignItems : 'center',*/}
            {/*    marginLeft : (theme) => theme.spacing(1),*/}
            {/*  }}*/}
            {/*  onClick={() => {*/}
            {/*    showRackCodeHistory(product)*/}
            {/*  }}*/}
            {/*>*/}
            {/*  <MoreHorizOutlined fontSize={'small'}/>*/}
            {/*</Box>*/}
          </Grid>
          {/*<Grid*/}
          {/*  item*/}
          {/*  xs={EXPIRE_DATE_SX}*/}
          {/*  sx={{*/}
          {/*    ...cellRows,*/}
          {/*    ...expireDateColor(product)*/}
          {/*  }}*/}
          {/*>*/}
          {/*  <Box>*/}
          {/*    {*/}
          {/*      product.expire_dates ?*/}
          {/*        product.expire_dates.split(',').map((d)=>*/}
          {/*          <div>{moment(new Date(d)).format('YYYY/MM')}</div>*/}
          {/*        ) : "-"*/}
          {/*    }*/}

          {/*  </Box>*/}

          {/*  /!*{product.expiration_dates || <br></br>}*!/*/}
          {/*</Grid>*/}
          <Grid
            item
            xs={COMMENT_SX}
            sx={{...cellRows}}
          >
            <Box
              sx={rowItemClickableFullWidth}
              style={{paddingTop : 16, paddingBottom : 16}}
              onClick={() => {
                getStockCommentAndShowHistory(product, index)
              }}
            >
              {product.stock_comment|| <br></br>}
            </Box>
            {/*<Box*/}
            {/*  sx={centerHistoryIcon}*/}
            {/*  onClick={() => {*/}
            {/*    showStockCommentHistory(product)*/}
            {/*  }}*/}
            {/*>*/}
            {/*  <MoreHorizOutlined fontSize={'small'}/>*/}
            {/*</Box>*/}
          </Grid>
          {
            renderCenterStocks(index, product)
          }
        </Grid>

        </div>
      <Divider light/>
    </div>
  }

  const isShowScrollbar = () => {
    // var div = document.getElementById('product_list')

    // console.log('scrollHeight ' + window.visualViewport.height + ' ' + window.outerHeight)
    // if (ref && ref.current) {
    //   console.log('scrollHeight ' + ref.current.clientHeight + ' ' + window.visualViewport.height)
    //   return ref.current.clientHeight > window.visualViewport.height;
    // }
    let height = products.length * ROW_HEIGHT

    if(height > (windowHeight - 103.5)){
      return true
    }

    return false
  }

  const calSxForName = () => {
    if(warehouseState && warehouseState.data && warehouseState.data.results){
      return TOTAL_COLUMNS - RACKCODE_SX - COMMENT_SX - (WAREHOUSE_SX * warehouseState.data.results.length)
    }
    return TOTAL_COLUMNS - RACKCODE_SX - COMMENT_SX
  }


  const isSeochoCode = (code, warehouses) =>{
    // console.log('isSeochoCode ', code, warehouses)
    code = code.trim()

    if(code.startsWith('S')){
      return true
    }
    for(const warehouse of warehouses){
      if(warehouse.code !== 'S' && code.startsWith(warehouse.code)){
        return false
      }
    }

    return true
  }

  useEffect(() => {
    if(productState.data){
      // store balance filter
      // console.log('centerIDForStoreBalance ', centerIDForStoreBalance)
      let storeBalanceProducts = centerIDForStoreBalance != null ? productState.data.filter((p) => {
        for(let stock of p.stocks){
          if(centerIDForStoreBalance === stock.center_id){
            return stock.store_balance < 0;
          }
        }
        return false
      }) : productState.data

      // console.log('centerIDForStoreBalance results ', storeBalanceProducts)

      // stock comment filter
      let products = applyStockCommentFilter ? storeBalanceProducts.filter((p) => p.stock_comment && p.stock_comment.length > 0)
          : storeBalanceProducts

      let products_stock = props.products && props.products.length > 0 ? props.products : products;
      if (stockCountFilter.size > 0) {
        products_stock = products_stock.filter((p) => {
          for (let stock of p.stocks) {
            if (stockCountFilter.has(stock.center_id)) {
              const stockCount = getCenterStock(stock);
              if (Number(stockCount) === 0) {
                return false;
              }
            }
          }
          return true;
        });
      }
      products = products_stock;


      // if(stockCountFilter.size > 0){
      //   products = products.filter((p)=>{
      //     for(let stock of p.stocks){
      //       if(stockCountFilter.has(stock.center_id)){
      //         const stockCount = getCenterStock(stock)
      //         if(Number(stockCount) === 0){
      //           return false;
      //         }
      //       }
      //     }
      //
      //     return true;
      //
      //   })
      // }

      // console.log('products ', products)
      // console.log('expireDateFilter ', expireDateFilter)
      let expireDateFilteredProducts = expireDateFilter !== null ? [...products].sort((a, b)=>{
          const expireDateA = getRecentExpireDate(a, expireDateFilter)
          const expireDateB = getRecentExpireDate(b, expireDateFilter)

          if(expireDateA != null && expireDateB != null){
            console.log(expireDateA.toString() , expireDateB.toString(), expireDateA.toString() < expireDateB.toString())
            if(expireDateA.toString() < expireDateB.toString()){
              return -1
            }else if(expireDateA.toString() > expireDateB.toString()){
              return 1
            }
          }else if(expireDateA != null && expireDateB === null){
            return -1
          }else if(expireDateA === null && expireDateB != null){
            return 1
          }

          return 0;
        }) : products
      // console.log('expireDateFilteredProducts ', expireDateFilteredProducts)

      // setProducts(products)

      // center code filter
      if(centerCode === 'ALL'){
        setProducts(expireDateFilteredProducts)
      }else{
        const filteredProduct = expireDateFilteredProducts.filter((p)=> {
          if(p.gsheet_rack_code){
            let rackCodes = p.gsheet_rack_code.split(',')
            if(centerCode === 'S'){
              for(const code of rackCodes){
                if(isSeochoCode(code, warehouseState.data.results)){
                  return true
                }
              }
            }else{
              for(const code of rackCodes){
                if(code.startsWith(centerCode)){
                  return true
                }
              }
            }

          }

          return false
        })


        // warehouse filter
        const centerId = getWarehouseCenterIdFromCode(centerCode, warehouseState)
        const newProducts = filteredProduct.map((p)=>{
          const newProduct = {...p}
          newProduct.gsheet_rack_code = getRackCodeByCenterId(centerId, warehouseState, newProduct.gsheet_rack_code)
          return newProduct
        })


        const orderedNewProducts = newProducts.sort((a, b)=>{
          let aRackCode = a.gsheet_rack_code.replace('-','')
          let bRackCode = b.gsheet_rack_code.replace('-','')
          if(aRackCode.startsWith(centerCode)){
            aRackCode = aRackCode.replace(centerCode, '')
          }
          if(bRackCode.startsWith(centerCode)){
            bRackCode = bRackCode.replace(centerCode, '')
          }

          if(aRackCode > bRackCode){
            return 1;
          }else if(aRackCode < bRackCode){
            return -1
          }

          return 0
        })
        setProducts(orderedNewProducts)
      }
    }

  }, [centerCode, applyStockCommentFilter, centerIDForStoreBalance, stockCountFilter, expireDateFilter]);

  const ProductList = () => (
    <div>
      <Grid style={{fontSize : 14, backgroundColor : "lightgrey", paddingRight : isShowScrollbar() ? width : 0}}
            columns={TOTAL_COLUMNS}
            container component="div">
        <Grid
          item xs={calSxForName()}
          sx={{
            ...cell_first,
          }}
        >
          상품명
        </Grid>
        <Grid
          item
          sx={{...cell, cursor : 'pointer'}}
          xs={RACKCODE_SX}
          // onClick={(e)=>{
          //   setCenterMenuAnchor(e.currentTarget)
          // }}
        >
          <Box>위치 코드</Box>
          <Box
            sx={centerHistoryIcon}
            style={{paddingLeft : 4, paddingTop : 0, paddingBottom : 0}}
          >
            {/*{*/}
            {/*  centerCode ?*/}
            {/*    <FilterList color={'success'} fontSize={'small'}/>*/}
            {/*    :*/}
            {/*    <FilterList color={'disabled'} fontSize={'small'}/>*/}
            {/*}*/}
            <Select
              value={centerCode}
              defaultValue={centerCode}
              label=""
              style={{
                marginLeft : 1,
                paddingTop : 0,
                paddingBottom : 0,
                fontSize : 13,
                height : 20
              }}
              onChange={(e)=>{
                setCenterCode(e.target.value)
              }}
            >
              <MenuItem id={"-1"} value={'ALL'}>
                {"모두"}
              </MenuItem>
              {
              warehouseState && warehouseState.data && warehouseState.data.results ?
                warehouseState.data.results.map((warehouse)=>
                  <MenuItem id={warehouse.id} value={warehouse.code}>
                    {warehouse.name}
                  </MenuItem>
                )
                : null
              }
            </Select>
          </Box>
        </Grid>
        {/*<Menu*/}
        {/*  anchorEl={centerMenuAnchor}*/}
        {/*  open={centerMenuAnchor != null}*/}
        {/*  onClose={()=>{*/}
        {/*    setCenterMenuAnchor(null)*/}
        {/*  }}*/}
        {/*>*/}
        {/*  <MenuItem id={-1} onClick={()=>{*/}
        {/*      setCenterCode(null)*/}
        {/*      setCenterMenuAnchor(null)*/}
        {/*  }}>*/}
        {/*    {"모두"}*/}
        {/*  </MenuItem>*/}
        {/*  {*/}
        {/*    warehouseState && warehouseState.data && warehouseState.data.results ?*/}
        {/*      warehouseState.data.results.map((warehouse)=>*/}
        {/*        <MenuItem id={warehouse.id} onClick={()=>{*/}
        {/*            setCenterCode(warehouse.code)*/}
        {/*            setCenterMenuAnchor(null)*/}
        {/*        }}>*/}
        {/*          {warehouse.name}*/}
        {/*        </MenuItem>*/}
        {/*      )*/}
        {/*      : null*/}
        {/*  }*/}
        {/*</Menu>*/}
        {/*<Grid*/}
        {/*  item*/}
        {/*  xs={EXPIRE_DATE_SX}*/}
        {/*  sx={{...cell}}*/}
        {/*>*/}
        {/*  유통기한*/}
        {/*</Grid>*/}
        <Grid
          item xs={COMMENT_SX}
          sx={{...cell, cursor : 'pointer'}}
          onClick={() => {
            // setBalanceFilterShowState(new Set())
            // if(!applyStockCommentFilter) {
            //   let filteredProducts = productState.data.filter((p) => p.stock_comment && p.stock_comment.length > 0)
            //   setProducts(filteredProducts)
            //
            // }else{
            //   setProducts(productState.data)
            // }

            setApplyStockCommentFilter(!applyStockCommentFilter)
          }}
        >
          <Box>입고 코멘트</Box>
          <Box
            sx={centerHistoryIcon}
            style={{paddingLeft : 4, paddingTop : 0, paddingBottom : 0}}
          >
            {
              applyStockCommentFilter?
                <FilterList color={'success'} fontSize={'small'}/>
                :
                <FilterList color={'disabled'} fontSize={'small'}/>
            }

          </Box>
        </Grid>
        {
          warehouseState.data.results.map((warehouse)=>{
            return <Grid
                item xs={WAREHOUSE_SX}
              >
                <Grid container columns={2}>
                  <Grid item
                        xs={1}
                        sx={{
                          ...cell,
                        }}
                  >
                    <div>{warehouse.name}</div>
                    <Box
                      sx={centerHistoryIcon}
                      style={{paddingLeft : 4, paddingTop : 0, paddingBottom : 0}}
                      onClick={()=>{
                        console.log('onClick StockCount Filter ', warehouse.id)
                        const newFilter = new Set(stockCountFilter)
                        if(stockCountFilter.has(warehouse.id)) {
                          newFilter.delete(warehouse.id)
                        }else {
                          newFilter.add(warehouse.id)

                        }
                         setStockCountFilter(newFilter)
                      }}
                    >
                      {
                        stockCountFilter.has(warehouse.id)?
                          <FilterList color={'success'} fontSize={'small'}/>
                          :
                          <FilterList color={'disabled'} fontSize={'small'}/>
                      }

                    </Box>
                    {
                      storeBalanceFilter.has(warehouse.id) ?
                        <Box
                          sx={centerHistoryIcon}
                          style={{paddingTop : 0, paddingBottom : 0}}
                          onClick={() => {
                            if(centerIDForStoreBalance === warehouse.id){
                              setCenterIDForStoreBalance(null)
                            }else{
                               setCenterIDForStoreBalance(warehouse.id)
                            }

                          }}
                        >
                          {
                            centerIDForStoreBalance === warehouse.id ?
                              <Error color={'secondary'} fontSize={'small'}/>
                              :
                              <ErrorOutline color={'secondary'} fontSize={'small'}/>
                          }
                        </Box>
                        :
                        <div/>
                    }
                  </Grid>
                  <Grid
                    item
                    xs={1}
                    sx={{
                      display: 'flex',
                      alignItems : 'center',
                      pl : 1,
                      cursor : 'pointer'
                      // borderLeftWidth : 0.3,
                      // borderLeftColor : '#B0BEC5',
                      // borderLeftStyle : 'solid',
                    }}
                    onClick={()=>{
                      if(expireDateFilter === warehouse.id) {
                        setExpireDateFilter(null)
                        return
                      }
                      // setCenterIDForStoreBalance(null)
                      // setApplyStockCommentFilter(null)
                      // setStockCountFilter(new Set())
                      // setCenterCode('ALL')
                      setExpireDateFilter(warehouse.id)
                    }}
                  >
                    <Box sx={{mr : 1}}>
                      {"유통기한"}
                    </Box>

                    {
                      expireDateFilter === warehouse.id ?
                        <FilterList color={'error'} fontSize={'small'}/>
                        :
                        <FilterList color={'disabled'} fontSize={'small'}/>
                    }
                  </Grid>
                </Grid>

              </Grid>

          })
        }
      </Grid>
      <FixedSizeList
        itemCount={products.length}
        height={windowHeight - 103.5}
        width={windowWidth > MOBILE_WIDTH_THRESHOLD ? windowWidth : MOBILE_WIDTH_THRESHOLD}
        // width={windowWidth}
        itemSize={ROW_HEIGHT}
        itemData={products.data}
        style={{
          padding : 0,
        }}>
        {productRow}
      </FixedSizeList>

    </div>

  );

  const product_list = useMemo(()=> ProductList(), [ProductList])

  const postGsheetRackCode = () => {
    const {product, newData, index} = editDialog
    setRequesting(true)
    setEditDialog({
      ...editDialog,
      open : false,
    })
    let new_gsheetRackCode = newData ? newData.replace(' ', '') : ''
    axios.post(`${process.env.REACT_APP_API_HOST}/product/gsheet_rack_code`, {
      params : {
        token : cookie.load(RECEIVER_COOKIE_KEY)
      },
      id_fs : product.id_fs,
      gsheet_rack_code : new_gsheetRackCode,
    }).then(resp => {
      console.log(resp)
      console.log(centerIDForStoreBalance)


      if(resp.status === 200 && resp.data != null && resp.data['code'] === 200) {
        updateGsheetRackCode(index, product.id_fs, new_gsheetRackCode)
        enqueueSnackbar(`"${product.name}" - 위치코드를 업데이트 했습니다..`, {variant : 'success'})
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
        history.replace('/signin')
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 499){
        cookie.remove(RECEIVER_COOKIE_KEY)
        history.replace('/not-permitted')
      }else{
        // setSnackbar({
        //   open : true,
        //   message : '위치코드 업데이트를 실패 했습니다.',
        // })

        enqueueSnackbar(`"${product.name}" - 위치코드 업데이트를 실패했습니다.`, {variant : 'error'})
      }

    }).catch((error) => {
      console.log('error', error)
      // setSnackbar({
      //   open : true,
      //   message : '위치코드 업데이트를 실패 했습니다.',
      // })
      enqueueSnackbar(`"${product.name}" - 위치코드 업데이트를 실패했습니다.`, {variant : 'error'})
    }).finally(() => {
      setRequesting(false)
    })
  }

  const postStockComment = () => {
    const {product, newData, index} = editDialog
    setRequesting(true)
    setEditDialog({
      ...editDialog,
      open : false,
    })
    axios.post(`${process.env.REACT_APP_API_HOST}/product/stock_comment`, {
      params : {
        token : cookie.load(RECEIVER_COOKIE_KEY)
      },
      id_fs : product.id_fs,
      stock_comment : newData,
    }).then(resp => {
      console.log(resp)
      if(resp.status === 200 && resp.data != null && resp.data['code'] === 200) {
        updateStockComment(index, product.id_fs, newData)
        enqueueSnackbar(`"${product.name}" - 입고코멘트가 업데이트 되었습니다.`, {variant : 'success'})
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
        history.replace('/signin')
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 499){
        cookie.remove(RECEIVER_COOKIE_KEY)
        history.replace('/not-permitted')
      }else{
        enqueueSnackbar(`"${product.name}" - 입고코멘트 업데이트를 실패 했습니다.`, {variant : 'error'})
      }

    }).catch((error) => {

      enqueueSnackbar(`"${product.name}" - 입고코멘트 업데이트를 실패 했습니다.`, {variant : 'error'});
    }).finally(() => {
      setRequesting(false)
    })
  }

  const updateCenterStock = (center_id, product, new_center_stock) => {
    if(product){
      for(let stock of product.stocks){
        if(stock.center_id === center_id){
          stock.center_stock = new_center_stock.center_stock;
          stock.store_balance = new_center_stock.store_balance;
          stock.naver_stock = new_center_stock.naver_stock;
          stock.coupang_stock = new_center_stock.coupang_stock;
          stock.out_stock = new_center_stock.out_stock;
        }
      }
    }
  }

  const postProductInfo = () => {
    const {product, newData, newData2, index} = editDialog
    setRequesting(true)
    setEditDialog({
      ...editDialog,
      open : false,
    })

    axios.post(`${process.env.REACT_APP_API_HOST}/product/info`, {
      params : {
        token : cookie.load(RECEIVER_COOKIE_KEY)
      },
      id_fs : product.id_fs,
      id : newData,
      opt_code : newData2,
    }).then(resp => {
      console.log(resp)
      if(resp.status === 200 && resp.data != null && resp.data['code'] === 200) {

        updateProductInfo(index, product.id_fs, newData, newData2)

        enqueueSnackbar(`"${product.name}" - 정보가 업데이트 되었습니다.`, {variant : 'success'})
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
        history.replace('/signin')
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 499){
        cookie.remove(RECEIVER_COOKIE_KEY)
        history.replace('/not-permitted')
      }else{
        enqueueSnackbar(`"${product.name}" - 재고 업데이트를 실패 했습니다.`, {variant : 'error'})
      }
    }).catch((error) => {
      console.log('error', error)
      // setSnackbar({
      //   open : true,
      //   message : '재고 업데이트를 실패 했습니다.',
      // })
      enqueueSnackbar(`"${product.name}" - 재고 업데이트를 실패 했습니다.`, {variant : 'error'})
    }).finally(() => {
      setRequesting(false)
    })
  }

  const postCenterStock = (center_id) => {
    const {product, newData, index, history, originalData} = editDialog
    
    // Calculate new_quantity as the delta: (input total - current top row total "총")
    const inputQty = changeStockValue(newData)
    let editableStock = 0  // 수정 가능 재고 (사사로이 + 쿠팡 + 저장)
    let fixedStock = 0     // 고정 재고 (최저가만세 + 출고예정)
    let originalTotal = 0  // 총재고
    let coupangStock = 0   // 쿠팡 재고 (블록 밖에서 사용되므로 함수 스코프에 선언)
    
    if (history && history.length > 0) {
      const top = history[0]
      
      // Get naver_stock from naver_stock_detail
      let sasaroiStock = 0
      let otherNaverStock = 0  // 사사로이가 아닌 모든 네이버 재고 (고정 재고)
      
      if (Array.isArray(top?.naver_stock_detail)) {
        for (const item of top.naver_stock_detail) {
          const stockQty = Number(item?.stock_quantity || 0)
          if (item.ss_name === '사사로이') {
            sasaroiStock += stockQty
          } else {
            // 사사로이가 아닌 모든 판매처는 고정 재고
            otherNaverStock += stockQty
          }
        }
      }
      
      coupangStock = Number(top?.coupang_stock || 0)
      const centerStock = Number(top?.center_stock || 0)
      const outStock = Number(top?.out_stock || 0)
      
      // 수정 가능 재고 = 사사로이 + 기타 네이버 재고 + 저장
      editableStock = sasaroiStock + otherNaverStock + centerStock
      
      // 고정 재고 = 쿠팡 재고 + 출고예정
      fixedStock = coupangStock + outStock
      
      // 총재고(서버 기준) = 사사로이 + 사사로이 외 네이버 재고 + 쿠팡 + 저장 + 출고예정
      originalTotal = sasaroiStock + otherNaverStock + coupangStock + centerStock + outStock
      // 화면 표시 총(네이버 상세 합계(사사로이는 출고예정+저장 보정) + 쿠팡)
      var displayedNaverAdjusted = otherNaverStock + (sasaroiStock + outStock + centerStock)
      var displayedTotal = displayedNaverAdjusted + coupangStock
    }
    
    // 입력된 수정 가능 재고 = 사용자 입력 총재고 - 고정 재고
    const inputEditableStock = inputQty - fixedStock
    
    // new_quantity는 변화량 (입력 총재고 - 현재 총재고)
    const newQuantity = inputQty - originalTotal

    // 디버깅 로그
    console.log('=== postCenterStock Debug ===')
    console.log('newData:', newData)
    console.log('history:', history)
    console.log('history[0]:', history?.[0])
    console.log('naver_stock_detail:', history?.[0]?.naver_stock_detail)
    console.log('계산 결과:', {
      inputQty,
      originalTotal,
      newQuantity,
      editableStock,
      fixedStock,
      inputEditableStock
    })

    // Validation 1: 음수 입력 체크
    if (inputQty < 0) {
      setDialog({
        open: true,
        title: '재고 수정 오류',
        message: '재고는 0보다 작은 값을 입력할 수 없습니다',
        sub_messages: [],
      })
      
      setEditDialog({
        ...editDialog,
        newData: originalData,
      })
      
      return
    }

    // Validation 2: 현재 총재고와 동일한 값 입력 체크
    if (inputQty === originalTotal) {
      // 현재 재고가 0인데 0을 입력한 경우: 0으로는 수정요청을 허용하지 않는다
      if (originalTotal === 0 && inputQty === 0) {
        setDialog({
          open: true,
          title: '재고 수정 오류',
          message: '현재 재고가 0인 상품은 0으로 수정요청할 수 없습니다. 다른 값으로 입력해 주세요.',
          sub_messages: [],
        })

        setEditDialog({
          ...editDialog,
          newData: '',
        })
      } else {
        setDialog({
          open: true,
          title: '재고 수정 알림',
          message: '현재 재고 수와 같은 값이 입력됐습니다',
          sub_messages: [
            `현재 총재고: ${originalTotal}`,
            `입력값: ${inputQty}`
          ],
        })

        setEditDialog({
          ...editDialog,
          open: false,
        })
      }

      return
    }

    // Validation 3: 재고를 줄이는 경우에만 체크 (입력값 < 현재 총재고)
    // 재고를 늘리는 경우(입력값 >= 현재 총재고)는 제한 없음
    if (inputQty < originalTotal) {
      // 입력된 수정 가능 재고가 0보다 작은지 체크 (고정 재고보다 작은 값 입력)
      if (inputEditableStock < 0) {
        setDialog({
          open: true,
          title: '재고 수정 오류',
          message: `${fixedStock}개 이상으로 재고 수정 요청이 가능합니다.`,
          sub_messages: [
            `문제가 계속 발생하면 관리자에게 문의해주세요.`
          ],
        })
        
        setEditDialog({
          ...editDialog,
          newData: originalData,
        })
        
        return
      }
    }

    setRequesting(true)
    setEditDialog({
      ...editDialog,
      open : false,
    })

    axios.post(`${process.env.REACT_APP_API_HOST}/product/total_stock`, {
      params : {
        token : cookie.load(RECEIVER_COOKIE_KEY)
      },
      id_fs : product.id_fs,
      center_id : center_id,
      by : HISTORY_TYPE_EDIT,
      new_quantity : newQuantity,
      product_id : product.id,
      product_opt_code : product.opt_code,
      current_total: (typeof displayedTotal === 'number' ? displayedTotal : originalTotal),
      cp_quantity: coupangStock,
      req_type: editDialog.req_type,
      etc_reason: (editDialog.req_type === '기타' ? editDialog.etc_reason : ''),
    }).then(resp => {
      console.log(resp)
      if(resp.status === 200 && resp.data != null && resp.data['code'] === 200) {
        // /product/total_stock 응답은 실제 재고값을 즉시 변경하지 않고
        // 백엔드에서 비동기 처리 후 /product, /product/quantity_update_status 에 반영된다.
        // 따라서 현재 화면의 재고 숫자는 변경하지 않고,
        // 해당 상품을 "수정요청 진행 중" 상태로만 표시한다.

        // quantityUpdateIdfs 에 현재 상품 id_fs 를 추가하여 별(*) 표시
        addQuantityUpdating(productsDispatch, product.id_fs)

        enqueueSnackbar(`"${product.name}" - 재고가 업데이트 되었습니다.`, {variant : 'success'})
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
        history.replace('/signin')
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 499){
        cookie.remove(RECEIVER_COOKIE_KEY)
        history.replace('/not-permitted')
      }else{
        // setSnackbar({
        //   open : true,
        //   message : '재고 업데이트를 실패 했습니다.',
        // })
        enqueueSnackbar(`"${product.name}" - 재고 업데이트를 실패 했습니다.`, {variant : 'error'})
      }
    }).catch((error) => {
      console.log('error', error)
      // setSnackbar({
      //   open : true,
      //   message : '재고 업데이트를 실패 했습니다.',
      // })
      enqueueSnackbar(`"${product.name}" - 재고 업데이트를 실패 했습니다.`, {variant : 'error'})
    }).finally(() => {
      setRequesting(false)
    })
  }


  const postEdit = () => {
    if(editDisabled()){
      console.log('is disabled state ' + editDialog)
      return
    }
    // 수량 업데이트 진행 중인 상품이면 재고수정 요청을 막고 경고 팝업 후 다이얼로그를 닫는다
    if (editDialog.type === EDIT_TYPE_CENTER_STOCK) {
      const isUpdating = Array.isArray(productState.quantityUpdateIdfs) && productState.quantityUpdateIdfs.includes(editDialog.product?.id_fs)
      if (isUpdating) {
        setDialog({
          open: true,
          title: '안내',
          message: '이전 수정요청이 완료되지 않았습니다.',
          sub_messages: []
        })
        setEditDialog({ ...editDialog, open: false })
        return
      }
    }
    switch (editDialog.type) {
      case EDIT_TYPE_RACK_CODE:
        postGsheetRackCode()
        break;
      case EDIT_TYPE_STOCK_COMMENT:
        postStockComment()
        break;
      case EDIT_TYPE_CENTER_STOCK:
        postCenterStock(editDialog.center_id)
        break;
      case EDIT_TYPE_PRODUCT_INFO:
        postProductInfo()
        break;
      default:
        break;
    }
  }

  const fixStoreBalance = (center_id) => {
    const {product, store, index} = storeBalanceDialog
    setRequesting(true)
    setStoreBalanceDialog({
      ...storeBalanceDialog,
      open : false,
    })


    axios.post(`${process.env.REACT_APP_API_HOST}/product/fix_store_balance`, {
      params : {
        token : cookie.load(RECEIVER_COOKIE_KEY)
      },
      id_fs : product.id_fs,
      center_id : center_id,
      store : store,
    }).then(resp => {
      console.log(resp)
      if(resp.status === 200 && resp.data != null && resp.data['code'] === 200) {
        const newProducts = [...products]

        let results = resp.data['results']

        updateCenterStock(center_id, newProducts[index], results)
        console.log(isApplyingFilter())
        console.log(props.products)
        console.log(newProducts)
        if((props.products && props.products.length > 0) || isApplyingFilter()) {
          // 검색결과인경우
          setProducts(newProducts)
          for(let p of productState.data) {
            if(p.id_fs === product.id_fs) {
              updateCenterStock(center_id, p, results)
              break
            }
          }

        }else{
          // 모든 리스트인 경우
          setNewProducts(productsDispatch, newProducts)
        }

        checkStoreBalanceFilter()

        // setSnackbar({
        //   open : true,
        //   message : '재고가 업데이트 되었습니다.',
        // })
        enqueueSnackbar(`"${product.name}" - 재고가 업데이트 되었습니다.`, {variant : 'success'})

      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
        history.replace('/signin')
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 499){
        cookie.remove(RECEIVER_COOKIE_KEY)
        history.replace('/not-permitted')
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 451) {
        setDialog({
          open: true,
          title: '스토어 재고 변경 에러',
          message: '스토어 재고 수정 권한이 없습니다. 직원에게 문의해 주세요',
          sub_messages: []
        })
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 491){
        setDialog({
          open: true,
          title: '스토어 재고 변경 에러',
          message: '스토어재고가 이미 수정되었습니다. 상품정보를 리프레시 해보세요',
          sub_messages: []
        })
      }else{
        // setSnackbar({
        //   open : true,
        //   message : '재고 업데이트를 실패 했습니다.',
        // })
        enqueueSnackbar(`"${product.name}" - 재고 업데이트를 실패 했습니다.`, {variant : 'error'})
      }
    }).catch((error) => {
      console.log('error', error)
      // setSnackbar(zk{
      //   open : true,
      //   message : '재고 업데이트를 실패 했습니다.',
      // })
      enqueueSnackbar(`"${product.name}" - 재고 업데이트를 실패 했습니다.`, {variant : 'error'})
    }).finally(() => {
      setRequesting(false)
    })
  }

  const checkStoreBalanceFilter = () =>{
    // let has_s_storebalance = false
    // let has_y_storebalance = false

    // setCenterIDForStoreBalance(null)
    let storeBalanceFilter = new Set()
    for(let product of productState.data){
      for(let stock of product.stocks){
        if(stock.store_balance < 0){
          storeBalanceFilter.add(stock.center_id)
        }
      }
      // if(product.s_stocks && product.s_stocks.store_balance < 0){
      //   has_s_storebalance = true
      // }
      // if(product.y_stocks && product.y_stocks.store_balance < 0){
      //   has_y_storebalance = true
      // }
    }

    setStoreBalanceFilter(storeBalanceFilter)
  }

  useEffect(()=>{
    console.log('useEffect ', productState)
    if(productState.errorProduct && productState.errorProduct.length > 0){
      setDialog({
        open: true,
        title: '아래 상품들의 스토어 등록정보에 중복 데이터가 존재 합니다. ',
        message: '문제가 해결될때까지 재고개수가 0으로 표시됩니다. 직원에게 문의 해주세요',
        sub_messages: productState.errorProduct.map((item) => '(' + item.id_fs + ') ' + item.name)
      })
    }

  }, [])

  useEffect(() => {
    // console.log('scrollBarWidth', width, height)
    // console.log('props.products', props.products)
    // console.log('productState', productState)
    if(props.products && props.products.length > 0) {
      if(props.products.length === 1){
        let filtered = productState.data.filter(p => {
          for(var product of props.products){
            if(p.id === product.id && p.opt_code !== product.opt_code ){
              return true;
            }
          }

          return false;


        })

        setProducts([...props.products, ...filtered])
      }else{
        setProducts(props.products)
      }

      // setProducts(props.products)


    }else if(productState.data){

      setCenterIDForStoreBalance(null)
      setApplyStockCommentFilter(null)
      setCenterCode('ALL')
      setExpireDateFilter(null)
      checkStoreBalanceFilter()

      setProducts(productState.data)
    }
  }, [productState, productState.data, productState.loading, props.products])

  if (productState.loading) {
    return <Box sx={{
      marginTop: (theme) => theme.spacing(18),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'}}>
      <CircularProgress size={34} thickness={4}/>
    </Box>
  }


  const getEditTitle = (type, center_id) => {
    if (type === EDIT_TYPE_RACK_CODE) {
      return '위치 코드 변경'
    } else if (type === EDIT_TYPE_STOCK_COMMENT) {
      return '입고 코멘트 변경'
    } else if (type === EDIT_TYPE_CENTER_STOCK) {
      return getWarehouseName(center_id, warehouseState) + '재고 변경'
    } else if (type === EDIT_TYPE_PRODUCT_INFO) {
      return '상품 정보 변경'
    }
  }

  const getEditType = (type, center_id) => {
    if(type === EDIT_TYPE_CENTER_STOCK){
      return 'number';
    }else{
      return 'text'
    }
  }

  const getEditLabel = (type, center_id) => {
    if (type === EDIT_TYPE_RACK_CODE) {
      return '위치 코드'
    } else if (type === EDIT_TYPE_STOCK_COMMENT) {
      return '입고 코멘트'
    } else if (type === EDIT_TYPE_CENTER_STOCK) {
      return '재고수'
    } else if (type === EDIT_TYPE_PRODUCT_INFO) {
      return '상품코드'
    }
  }

  const getEditLabel2 = (type) => {
    if (type === EDIT_TYPE_RACK_CODE) {
      return ''
    } else if (type === EDIT_TYPE_STOCK_COMMENT) {
      return ''
    } else if (type === EDIT_TYPE_CENTER_STOCK) {
      return '수정요청'
    } else if (type === EDIT_TYPE_PRODUCT_INFO) {
      return '옵션코드'
    }
  }
  //
  // const getStockHistoryType = (type) => {
  //   switch (type) {
  //     case HISTORY_TYPE_RECV:
  //       return '입고'
  //     case HISTORY_TYPE_NAVER_RELEASE:
  //       return '네이버출고'
  //     case HISTORY_TYPE_COUPANG_RELEASE:
  //       return '쿠팡출고'
  //     case HISTORY_TYPE_EDIT:
  //       return '재고수정'
  //     case HISTORY_TYPE_STORE_FIX:
  //       return '스토어재고수정'
  //     case HISTORY_TYPE_GSHEET_EDIT:
  //       return '구글재고'
  //     default:
  //       return ''
  //   }
  // }

  const historyRow = (row, prev_row, key) => {
    switch (editDialog.type) {
      case EDIT_TYPE_CENTER_STOCK:
        return stockHistoryRow(row, prev_row, key)
      case EDIT_TYPE_RACK_CODE:
        return rackHistoryRow(row, key)
      case EDIT_TYPE_STOCK_COMMENT:
        return commentHistoryRow(row, key)
      case EDIT_TYPE_PRODUCT_INFO:
        return productInfoRow(row, key)
    }
  }

  const getSeperatedValues = (text) => {
    if(text.includes(ETC_SEPARATOR)){
      return text.split(ETC_SEPARATOR)
    }
    return text.split('/')
  }

  const rackHistoryRow = (row, key) => {
    let values = getSeperatedValues(row.event_target_value)

    let rack_prev = values[0]
    let rack_curr = values[1]
    return <ListItem key={key}>
      <ListItemText primary={'"' + row.user_name + '"이 위치코드를 "' + rack_curr + '"  로 변경함'}
                    secondary={moment(new Date(row.create_date)).format('YY년MM월DD일 HH:mm')}/>
    </ListItem>
  }

  const commentHistoryRow = (row, key) => {
    console.log("commentHistoryRow " + row.event_target_value + " " + row.event_target_value.includes(ETC_SEPARATOR))
    let values = getSeperatedValues(row.event_target_value)
    let rack_prev = values[0]
    let rack_curr = values[1]
    return <ListItem key={key}>
      <ListItemText primary={'"' + row.user_name + '"이 입고코멘트를 "' + rack_curr + '"  로 변경함'}
                    secondary={moment(new Date(row.create_date)).format('YY년MM월DD일 HH:mm')}/>
    </ListItem>
  }

  const productInfoRow = (row, key) => {
    let values = getSeperatedValues(row.event_target_value)
    let id = values[0]
    let opt_code = values[1]
    return <ListItem key={key}>
      <ListItemText primary={'"' + row.user_name + '"이 상품코드를 "' + id + '", ' + ' 옵션코드를 "' + opt_code + '" 로 변경함'}
                    secondary={moment(new Date(row.create_date)).format('YY년MM월DD일 HH:mm')}/>
    </ListItem>
  }

  const stockHistoryValueColor = (index, prev, curr) => {
    if(prev !== null && prev !== undefined){
      let diff = curr - prev
      // console.log("stockHistoryColor " + index + ', ' + diff + ' ' + curr + ' ' + prev)
      if(diff > 0){
        return 'green';
      }else if(diff < 0){
        return 'red';
      }else{
        return 'black';
      }
    }
    return 'black';
  }

  const stockHistoryTotalBgColor = (index, prev, curr) => {
    if(prev !== null && prev !== undefined){
      let diff = curr - prev
      // console.log("stockHistoryColor " + index + ', ' + diff + ' ' + curr + ' ' + prev)
      if(diff > 0){
        return 'green';
      }else if(diff < 0){
        return 'red';
      }else{
        return 'white';
      }
    }
    return 'white';
  }
  const stockHistoryTotalValueColor = (index, prev, curr) => {
    if(prev !== null && prev !== undefined){
      let diff = curr - prev
      // console.log("stockHistoryColor " + index + ', ' + diff + ' ' + curr + ' ' + prev)
      if(diff > 0){
        return 'white';
      }else if(diff < 0){
        return 'white';
      }else{
        return 'black';
      }
    }
    return 'black';
  }

  const boxStyle = {display : 'flex',
    flex : 1, alignItems : 'center', justifyContent : 'center',
    borderBottom : 1, borderTop : 0, borderLeft : 0, borderRight : 1, borderStyle : 'solid', borderColor : 'gray'}

  const stockHistoryRow = (row, prev_row, key) => {
    // let values = row.event_target_value.split('/')
    // let from = Number(values[0])
    // let to = Number(values[1])
    //
    // let diff = from - to

    let prev_history_center_stock
    let prev_history_store_balance
    let prev_history_naver_stock
    let prev_history_coupang_stock
    let prev_history_out_stock
    let prev_history_total_stock
    if(prev_row){
      let prev_history_values = getHistoryValues(prev_row.event_target_value, 3)
      let prev_history_ss_values = getHistoryValues(prev_row.event_target_ss_value, 2)
      let prev_history_cp_values = getHistoryValues(prev_row.event_target_cp_value, 2)
      let prev_history_out_values = getHistoryValues(prev_row.event_target_out_value, 2)
      prev_history_center_stock = Number(prev_history_values[1])
      prev_history_store_balance = Number(prev_history_values[2])
      prev_history_naver_stock = Number(prev_history_ss_values[1])
      prev_history_coupang_stock = Number(prev_history_cp_values[1])
      prev_history_out_stock = Number(prev_history_out_values[1])
      prev_history_total_stock = prev_history_naver_stock + prev_history_coupang_stock
    }

    if(row.curr){
      let naverAdjusted = row.naver_stock
      if (Array.isArray(row.naver_stock_detail) && row.naver_stock_detail.length > 0) {
        naverAdjusted = row.naver_stock_detail.reduce((acc, d) => {
          if (d.ss_name === '사사로이') {
            return acc + (Number(d.stock_quantity) + Number(row.out_stock) + Number(row.center_stock))
          }
          return acc + Number(d.stock_quantity)
        }, 0)
      }
      let totalStock = naverAdjusted + row.coupang_stock
      return <Box key={key} sx={{display : 'flex', flexBasis : 1 , height : STOCK_HISTORY_ROW_HEIGHT}}>
        <Box sx={{...boxStyle, flex : 1.5, fontSize : 15, fontWeight : 'bold', color: stockHistoryTotalValueColor(key, prev_history_total_stock, totalStock), backgroundColor : stockHistoryTotalBgColor(key, prev_history_total_stock, totalStock)}}>
          {getCleanStockValue(totalStock)}
        </Box>
        {
          Array.isArray(row.naver_stock_detail) && row.naver_stock_detail.length > 0 ?
            <Tooltip
              arrow
              placement="top"
              title={
                <Box sx={{p: 0.5}}>
                  {(() => {
                    // 사사로이 디버깅용 로그: 사사로이:(1+2+3)
                    const sasaroiItem = Array.isArray(row.naver_stock_detail)
                      ? row.naver_stock_detail.find((d) => d.ss_name === '사사로이')
                      : null
                    if (sasaroiItem) {
                      const base = Number(sasaroiItem.stock_quantity) || 0
                      const out = Number(row.out_stock) || 0
                      const center = Number(row.center_stock) || 0
                      console.log(`사사로이:(${base}+${out}+${center})`)
                    }

                    const sum = row.naver_stock_detail.reduce((acc, d) => {
                      if (d.ss_name === '사사로이') {
                        return acc + (Number(d.stock_quantity) + Number(row.out_stock) + Number(row.center_stock))
                      }
                      return acc + Number(d.stock_quantity)
                    }, 0)
                    return <div style={{fontWeight: 'bold'}}>{`네이버 합계 : ${sum}`}</div>
                  })()}
                  {row.naver_stock_detail.map((d, i) => (
                    <div key={i}>
                      {d.ss_name === '사사로이'
                        ? `${d.ss_name} : ${Number(d.stock_quantity) + Number(row.out_stock) + Number(row.center_stock)}`
                        : `${d.ss_name} : ${d.stock_quantity}`}
                    </div>
                  ))}
                </Box>
              }
            >
              <Box sx={{...boxStyle, fontSize : 14, color: stockHistoryValueColor(key, prev_history_naver_stock, naverAdjusted)}}>
                {getCleanStockValue(naverAdjusted)}
              </Box>
            </Tooltip>
            :
            <Box sx={{...boxStyle, fontSize : 14, color: stockHistoryValueColor(key, prev_history_naver_stock, naverAdjusted)}}>
              {getCleanStockValue(naverAdjusted)}
            </Box>
        }
        <Box sx={{...boxStyle, fontSize : 14, color: stockHistoryValueColor(key, prev_history_coupang_stock, row.coupang_stock)}}>
          {getCleanStockValue(row.coupang_stock)}
        </Box>
        <Box sx={{...boxStyle, flex : 4, fontSize : 14, flexDirection : 'column', alignItems : 'left'}} >
          <Box sx={{ml : 1, }}>{"현재"}</Box>
        </Box>
      </Box>

    }

    let values = getHistoryValues(row.event_target_value, 3)
    let ss_values = getHistoryValues(row.event_target_ss_value, 2)
    let cp_values = getHistoryValues(row.event_target_cp_value, 2)
    let out_values = getHistoryValues(row.event_target_out_value, 2)
    let center_stock_prev = Number(values[0])
    let center_stock_curr = Number(values[1])
    let store_balance = Number(values[2])
    let naver_stock_prev = Number(ss_values[0])
    let naver_stock_curr = Number(ss_values[1])
    let coupang_stock_prev = Number(cp_values[0])
    let coupang_stock_curr = Number(cp_values[1])
    let out_stock_prev = Number(out_values[0])
    let out_stock_curr = Number(out_values[1])

    let prev_total_stock = naver_stock_prev + coupang_stock_prev
    let curr_total_stock = naver_stock_curr + coupang_stock_curr

    // 센터 재고 변화량(현재 - 이전)
    let diff_center_stock = center_stock_curr - center_stock_prev
    let desc
    let store_balance_state = ''
    // let title
    let diff
    switch (row.event_sub_type) {
      case 10:
        {
          const parts = getSeperatedValues(row.event_target_value || '')
          const last = parts.length > 0 ? parts[parts.length - 1] : ''
          const n = Number(last)
          const signed = Number.isFinite(n) ? (n > 0 ? `+${n}` : `${n}`) : last
          const statusText = row.event_req_state === 'R' ? ' -> 수정 미완료' : (row.event_req_state === 'D' ? ' -> 수정 완료' : '')
          const statusColor = row.event_req_state === 'R' ? 'red' : (row.event_req_state === 'D' ? 'green' : 'inherit')
          desc = (<span>{`"${row.user_name}" 재고 수정 요청 ${signed}`}<span style={{color: statusColor}}>{statusText}</span></span>)
        }
        break
      case HISTORY_TYPE_NAVER_CENTER_CHANGED:
        let ss_prev_center = getWarehouseRackCode(Number(ss_values[2]), warehouseState)
        let ss_curr_center = getWarehouseRackCode(Number(ss_values[3]), warehouseState)

        desc = `"${row.user_name}" 네이버센터 ${ss_prev_center}->${ss_curr_center}`

        break
      case HISTORY_TYPE_COUPANG_CENTER_CHANGED:
        let cp_prev_center = getWarehouseRackCode(Number(cp_values[2]), warehouseState)
        let cp_curr_center =getWarehouseRackCode(Number(cp_values[3]), warehouseState)
        desc = `"${row.user_name}" 쿠팡센터 ${cp_prev_center}->${cp_curr_center}`
        break
      case HISTORY_TYPE_GSHEET_EDIT:
        // title = "[구글재고]"
        diff = curr_total_stock - prev_total_stock;
        if(diff > 0){
          desc = `"${row.user_name}" GS재고 +${getCleanStockValue(diff)}`
        }else{
          desc = `"${row.user_name}" GS재고 ${getCleanStockValue(diff)}`
        }
       break
      case HISTORY_TYPE_RECV:
        // title = "[입고]"
        // 입고는 센터 재고(event_target_value)의 변화량 기준으로 표시
        diff = diff_center_stock;
        if(diff >= 0){
          desc = `"${row.user_name}" 입고 +${getCleanStockValue(diff)}`
        }else{
          desc = `"${row.user_name}" 입고 ${getCleanStockValue(diff)}`
        }

        break
      case HISTORY_TYPE_NAVER_RELEASE:
      case HISTORY_TYPE_COUPANG_RELEASE:
        // title = "[스토어반영]"
        let store_name
        if(row.event_sub_type === HISTORY_TYPE_NAVER_RELEASE){
          store_name = '네이버'
        }else{
          store_name = '쿠팡'
        }

        desc = `"${row.user_name}" ${store_name} 반영 +${diff_center_stock} `
        break
      case HISTORY_TYPE_EDIT:

        if(store_balance < 0){
          store_balance_state = `(${store_balance})`
        }
        // title = '[재고수정]'
        diff = curr_total_stock - prev_total_stock;
        if(diff > 0){
          desc = `"${row.user_name}" 재고수정 +${diff}`
        }else{
          desc = `"${row.user_name}" 재고수정 ${diff}`
        }

        break
      case HISTORY_TYPE_STORE_FIX:
        // title = '[스토어재고수정]'
        let coupang_diff = coupang_stock_curr - coupang_stock_prev;
        let naver_diff = naver_stock_curr - naver_stock_prev;
        let coupang_desc = ''
        let naver_desc = ''
        if(coupang_diff !== 0){
          if(coupang_diff > 0){
            coupang_desc = ` 쿠팡 +${coupang_diff}`
          }else{
            coupang_desc = ` 쿠팡 ${coupang_diff}`
          }
        }

        if(naver_diff !== 0){
          if(naver_diff > 0){
            naver_desc = ` 네이버 +${naver_diff}`
          }else{
            naver_desc = ` 네이버 ${naver_diff}`
          }
        }

        if(naver_desc.length === 0 && coupang_desc.length ===0){
          naver_desc = ' 스토어 재고 수정'
        }

        desc = `"${row.user_name}"${coupang_desc}${naver_desc} `
        break
      case HISTORY_TYPE_EDIT_CENTER:
        // title = '[저장재고수정]'
        diff = center_stock_curr - center_stock_prev;
        if(diff > 0){
          desc = `"${row.user_name}" 저장재고 +${diff}`
        }else{
          desc = `"${row.user_name}" 저장재고 ${diff}`
        }

        break
      case HISTORY_TYPE_EDIT_OUT:
        // title = '[출고예정수정]'
        // desc = `"${row.user_name}" 출고 예정 수정`
        diff = out_stock_curr - out_stock_prev;
        if(diff > 0){
          desc = `"${row.user_name}" 출고예정 +${diff}`
        }else{
          desc = `"${row.user_name}" 출고예정 ${diff}`
        }

        break
      case HISTORY_TYPE_EDIT_NAVER:
        // title = '[네이버재고수정]'
        diff = naver_stock_curr - naver_stock_prev;
        if(diff > 0){
          desc = `"${row.user_name}" 네이버 +${diff}`
        }else{
          desc = `"${row.user_name}" 네이버 ${diff}`
        }
        // desc = `"${row.user_name}" 네이버 재고 수정`
        break
      case HISTORY_TYPE_EDIT_COUPANG:
        // title = '[쿠팡재고수정]'
        diff = coupang_stock_curr - coupang_stock_prev;
        if(diff > 0){
          desc = `"${row.user_name}" 쿠팡 +${diff}`
        }else{
          desc = `"${row.user_name}" 쿠팡 ${diff}`
        }
        // desc = `"${row.user_name}" 쿠팡 재고 수정`
        break
      default:
        desc = ''
        break
    }

    return <Box key={key} sx={{display : 'flex', flexBasis : 1 , height : STOCK_HISTORY_ROW_HEIGHT}}>

      <Box sx={{...boxStyle, flex : 1.5, fontSize : 15, fontWeight : 'bold', color: stockHistoryTotalValueColor(key, prev_history_total_stock, curr_total_stock), backgroundColor : stockHistoryTotalBgColor(key, prev_history_total_stock, curr_total_stock)}}>
        {getCleanStockValue(curr_total_stock) + store_balance_state}
      </Box>
      <Box sx={{...boxStyle, fontSize : 14, color: stockHistoryValueColor(key, prev_history_naver_stock, naver_stock_curr)}}>
        {getCleanStockValue(naver_stock_curr)}
      </Box>
      <Box sx={{...boxStyle, fontSize : 14, color: stockHistoryValueColor(key, prev_history_coupang_stock, coupang_stock_curr)}}>
        {getCleanStockValue(coupang_stock_curr)}
      </Box>
      <Box sx={{...boxStyle, flex : 4, fontSize : 14, flexDirection : 'column', alignItems : 'left'}} >
        <Box sx={{ml : 1}}>{moment(new Date(row.create_date)).format('YY년MM월DD일 HH:mm')}</Box>
        <Box sx={{ml : 1}}>{desc}</Box>
      </Box>
    </Box>

    // return <ListItem key={key}>
    //   <ListItemText primary={title}
    //                 // primary={"[" + getStockHistoryType(row.event_sub_type) + ']" ' + row.user_name + '"님 '+ desc}
    //                 secondary={
    //                   <div style={{display : 'flex', flexDirection : 'column'}}>
    //                     <Typography
    //                       component="span"
    //                       variant="body2"
    //                       color="textPrimary"
    //                     >
    //                       {desc}
    //                     </Typography>
    //                     <Typography
    //                       component="span"
    //                       variant="body2"
    //                       color="textPrimary"
    //                     >
    //                       {`재고 : ${curr_total_stock} (네이버 : ${naver_stock_curr}, 쿠팡 : ${coupang_stock_curr}, 출고예정 : ${out_stock}, 저장재고 : ${center_stock_curr})`}
    //                       {/*{'재고 : ' + curr_total_stock + ' (네이버 : ' + naver_stock_curr + ', 쿠팡 : ' + coupang_stock_curr + ', 출고예정 : ' + out_stock + ')'}*/}
    //                     </Typography>
    //                     {moment(new Date(row.create_date)).format('YY년MM월DD일 HH:mm') + ' '}
    //                   </div>
    //                 }/>
    //   <ListItemSecondaryAction>
    //     <Box sx={{
    //       width : (theme) => theme.spacing(2.5),
    //       height : (theme) => theme.spacing(2.5),
    //       borderRadius : (theme) => theme.spacing(2.5),
    //       backgroundColor : '#f5f5f5',
    //       radius : '50%',
    //       display : 'flex',
    //       alignItems : 'center',
    //       justifyContent : 'center',
    //     }}
    //     style={{backgroundColor : ((curr_total_stock - prev_total_stock < 0) ? 'red' : 'green'), color : "white", paddingBottom : 2}}>
    //       {(curr_total_stock - prev_total_stock < 0) ? '-' : '+'}
    //     </Box>
    //   </ListItemSecondaryAction>
    // </ListItem>
  }

  const onPassKeyPress = (e) => {
    if(e.key === 'Enter'){
      console.log('onPassKeyPress Enter ' ,e)
      postEdit()
    }
  }

  const closePopover = () => {
    setPopover({...popover, open: false})
  }

  const stockDetails = (product, center_id) => {
    if(product){
      for(let stock of product.stocks){
        if(stock.center_id === center_id){
          return <div style={{backgroundColor : 'lightgrey'}}>
            <p>{'네이버 ' + changeStockValue(stock.naver_stock) + ', 쿠팡 ' + changeStockValue(stock.coupang_stock) + ', 출고예정 ' + changeStockValue(stock.out_stock) + ', 저장재고 ' + changeStockValue(stock.center_stock)}</p>
          </div>
        }
      }
    }

    // switch (center_id){
    //   case CENTER_ID_SC:
    //     return <div style={{backgroundColor : 'lightgrey'}}>
    //       <p>{'네이버 ' + changeStockValue(product.s_stocks.naver_stock) + ', 쿠팡 ' + changeStockValue(product.s_stocks.coupang_stock) + ', 출고예정 ' + changeStockValue(product.s_stocks.out_stock)}</p>
    //     </div>
    //   case CENTER_ID_YS:
    //     return <div style={{backgroundColor : 'lightgrey'}}>
    //       <p>{'네이버 ' + changeStockValue(product.y_stocks.naver_stock) + ', 쿠팡 ' + changeStockValue(product.y_stocks.coupang_stock) + ', 출고예정 ' + changeStockValue(product.y_stocks.out_stock)}</p>
    //     </div>
    // }


    return <div/>
  }


  const editDisabled = () =>{
    if(editDialog.type === EDIT_TYPE_PRODUCT_INFO
      && !Boolean(editDialog.newData)){
      return true;
    }else if(editDialog.type === EDIT_TYPE_CENTER_STOCK
      && (!Boolean(editDialog.newData) && editDialog.newData !== 0)
    ){
      return true;
    }else if(editDialog.type === EDIT_TYPE_CENTER_STOCK && !editDialog.req_type){
      return true;
    }else if(
      editDialog.type === EDIT_TYPE_CENTER_STOCK
      && editDialog.req_type === '기타'
      && String(editDialog.etc_reason || '').trim().length === 0
    ){
      return true;
    }

    return false;
  }

  const showExpireDateDialog = (index, product, centerId, history) => {

    const years = []
    for(let i = 0 ; i < EXPIRE_DATE_MAX_YEAR; i++){
      let yearDate = moment().add(i, 'years').toDate();
      // console.log(years)
      years.push(yearDate)
    }

    setExpireDateDialog({
      open: true,
      years: years,
      index: index,
      product : product,
      centerId : centerId,
      history: history,
      expireDateList: [],
      listLoading: true,
    })

    axios.get(`${process.env.REACT_APP_API_HOST}/product/expire_date_list`, {
      params : {
        token : cookie.load(RECEIVER_COOKIE_KEY),
        id_fs : product.id_fs,
        center_id : centerId,
      },
      timeout : 15000,
    }).then(resp => {
      if(resp.status === 200 && resp.data != null && resp.data['code'] === 200) {
        const list = Array.isArray(resp.data.results) ? resp.data.results : []
        console.log(list);
        setExpireDateDialog(prev => ({...prev, expireDateList: list, listLoading: false}))
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
        history.replace('/signin')
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 499){
        cookie.remove(RECEIVER_COOKIE_KEY)
        history.replace('/not-permitted')
      }else{
        enqueueSnackbar("유통기한 목록을 가져오는데 실패했습니다.", {variant : 'error'})
        setExpireDateDialog(prev => ({...prev, listLoading: false}))
      }
    }).catch((error) => {
      console.log('error', error)
      enqueueSnackbar("유통기한 목록을 가져오는데 실패했습니다.", {variant : 'error'})
      setExpireDateDialog(prev => ({...prev, listLoading: false}))
    })
  }

  const removeExpireDateFromState = (index, id_fs, centerId, deleteDateStr) => {
    const newProducts = [...products]
    const target = newProducts[index]
    const formatted = moment(new Date(deleteDateStr)).format('YYYY-MM-DD 00:00:00')
    if(target && Array.isArray(target.stocks)){
      for(let stock of target.stocks){
        if(stock.center_id === centerId){
          if(stock.expire_dates){
            const arr = stock.expire_dates.split(',').filter(d => d !== formatted)
            stock.expire_dates = arr.join(',')
          }
          break
        }
      }
    }

    if((props.products && props.products.length > 0) || isApplyingFilter()) {
      setProducts(newProducts)
      for(let p of productState.data) {
        if(p.id_fs === id_fs) {
          p.stocks = newProducts[index].stocks
        }
      }
    }else{
      setNewProducts(productsDispatch, newProducts)
    }
  }

  const deleteExpireDate = (index, product, centerId, deleteDateStr) => {
    setExpireDateDialog(prev => ({...prev, listLoading: true}))
    axios.put(`${process.env.REACT_APP_API_HOST}/product/expire_date_delete`, {
      params : {
        token : cookie.load(RECEIVER_COOKIE_KEY)
      },
      idfs : product.id_fs,
      center_id : centerId,
      expire_date : moment(new Date(deleteDateStr)).format('YYYY/MM/DD HH:mm'),
    }).then(resp => {
      if(resp.status === 200 && resp.data != null && resp.data['code'] === 200) {
        removeExpireDateFromState(index, product.id_fs, centerId, deleteDateStr)
        enqueueSnackbar(`"${product.name}" - 유통기한을 삭제했습니다.`, {variant : 'success'})
        return Promise.all([
          axios.get(`${process.env.REACT_APP_API_HOST}/product/expire_date_list`, {
            params : {
              token : cookie.load(RECEIVER_COOKIE_KEY),
              id_fs : product.id_fs,
              center_id : centerId,
            },
            timeout : 15000,
          }),
          axios.get(`${process.env.REACT_APP_API_HOST}/product/expire_date_history`, {
            params : {
              token : cookie.load(RECEIVER_COOKIE_KEY),
              id_fs : product.id_fs,
              center_id : centerId,
            },
            timeout : 15000,
          })
        ])
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
        history.replace('/signin')
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 499){
        cookie.remove(RECEIVER_COOKIE_KEY)
        history.replace('/not-permitted')
      }else{
        enqueueSnackbar(`"${product.name}" - 유통기한 삭제를 실패했습니다.`, {variant : 'error'})
      }
    }).then(resps => {
      if(Array.isArray(resps)){
        const [listResp, histResp] = resps
        let updated = { listLoading: false }
        if(listResp && listResp.status === 200 && listResp.data && listResp.data['code'] === 200){
          const list = Array.isArray(listResp.data.results) ? listResp.data.results : []
          updated = { ...updated, expireDateList: list }
        }
        if(histResp && histResp.status === 200 && histResp.data && histResp.data['code'] === 200){
          const historyList = Array.isArray(histResp.data.results) ? histResp.data.results : []
          updated = { ...updated, history: historyList }
        }
        setExpireDateDialog(prev => ({...prev, ...updated}))
      }else{
        // backward safety for previous single response shape
        const resp = resps
        if(resp && resp.status === 200 && resp.data != null && resp.data['code'] === 200){
          const list = Array.isArray(resp.data.results) ? resp.data.results : []
          setExpireDateDialog(prev => ({...prev, expireDateList: list, listLoading: false}))
        }else{
          setExpireDateDialog(prev => ({...prev, listLoading: false}))
        }
      }
    }).catch((error) => {
      console.log('error', error)
      enqueueSnackbar(`"${product.name}" - 유통기한 삭제를 실패했습니다.`, {variant : 'error'})
      setExpireDateDialog(prev => ({...prev, listLoading: false}))
    })
  }

  const postExpireDate = (index, product, centerId, expireDate) => {
    setExpireDateDialog(prev => ({...prev, listLoading: true}))
    axios.post(`${process.env.REACT_APP_API_HOST}/product/expire_date`, {
      params : {
        token : cookie.load(RECEIVER_COOKIE_KEY)
      },
      idfs : product.id_fs,
      center_id : centerId,
      expire_date : moment(expireDate).format('YYYY/MM/DD HH:mm'),
    }).then(resp => {
      if(resp.status === 200 && resp.data != null && resp.data['code'] === 200) {
        updateExpireDate(index, product.id_fs, centerId, expireDate)
        enqueueSnackbar(`"${product.name}" - 유통기한을 업데이트 했습니다..`, {variant : 'success'})
        return Promise.all([
          axios.get(`${process.env.REACT_APP_API_HOST}/product/expire_date_list`, {
            params : {
              token : cookie.load(RECEIVER_COOKIE_KEY),
              id_fs : product.id_fs,
              center_id : centerId,
            },
            timeout : 15000,
          }),
          axios.get(`${process.env.REACT_APP_API_HOST}/product/expire_date_history`, {
            params : {
              token : cookie.load(RECEIVER_COOKIE_KEY),
              id_fs : product.id_fs,
              center_id : centerId,
            },
            timeout : 15000,
          })
        ])
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
        history.replace('/signin')
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 499){
        cookie.remove(RECEIVER_COOKIE_KEY)
        history.replace('/not-permitted')
      }else{
        // setSnackbar({
        //   open : true,
        //   message : '위치코드 업데이트를 실패 했습니다.',
        // })
        enqueueSnackbar(`"${product.name}" - 유통기한 업데이트를 실패했습니다.`, {variant : 'error'})
      }
    }).then(resps => {
      if(Array.isArray(resps)){
        const [listResp, histResp] = resps
        let updated = { listLoading: false }
        if(listResp && listResp.status === 200 && listResp.data && listResp.data['code'] === 200){
          const list = Array.isArray(listResp.data.results) ? listResp.data.results : []
          updated = { ...updated, expireDateList: list }
        }
        if(histResp && histResp.status === 200 && histResp.data && histResp.data['code'] === 200){
          const historyList = Array.isArray(histResp.data.results) ? histResp.data.results : []
          updated = { ...updated, history: historyList }
        }
        setExpireDateDialog(prev => ({...prev, ...updated}))
      }else{
        setExpireDateDialog(prev => ({...prev, listLoading: false}))
      }
    }).catch((error) => {
      console.log('error', error)
      // setSnackbar({
      //   open : true,
      //   message : '위치코드 업데이트를 실패 했습니다.',
      // })
      enqueueSnackbar(`"${product.name}" - 유통기한 업데이트를 실패했습니다.`, {variant : 'error'})
      setExpireDateDialog(prev => ({...prev, listLoading: false}))
    }).finally(() => {
      setRequesting(false)
    })
  }

  return (
    <Fragment>
      <FSBarcodeReader
        onRequestStart={() => setRequesting(true)}
        onRequestResults={(results, barcode) => {
          if (results.length > 0) {
            console.log(results[0]['id_fs']);
            setProducts(results)
            props.onSelected(results[0])
          } else {
            props.onNewBarcode(barcode)
          }
          setRequesting(false)
        }}
        onRequestError={(error) => {
          // setSnackbar({
          //   open : true,
          //   message : "바코드인식에 실패 하였습니다. (" + error + ")",
          // })
          enqueueSnackbar("바코드인식에 실패 했습니다. ", {variant: 'error'})
          setRequesting(false)
        }}
      />
      <div style={{
        position: 'absolute',
        padding: 0,
        left: 0,
        top: windowWidth > MOBILE_WIDTH_THRESHOLD ? '66px' : '114px',
        width: windowWidth,
      }}>
        {product_list}
      </div>
      <Dialog
        open={editDialog.open}
        onClose={() => {
          setEditDialog({...editDialog, open: false})
        }}
      >
        <DialogTitle id="alert-dialog-title">
          {getEditTitle(editDialog.type, editDialog.center_id)}
        </DialogTitle>
        <DialogContent sx={{m: 0, pb: (theme) => theme.spacing(0.5),}}>
          <div>{editDialog.product ? editDialog.product.name : ''}</div>
          {/*{*/}
          {/*  editDialog.type === EDIT_TYPE_CENTER_STOCK ?*/}
          {/*    stockDetails(editDialog.product, editDialog.center_id)*/}
          {/*    :*/}
          {/*    <div/>*/}
          {/*}*/}
        </DialogContent>

        <DialogContent aria-multiline={true}>
          {
            editDialog.type === EDIT_TYPE_CENTER_STOCK ?
              <Box sx={{ display: 'flex', gap: 1 }}>
                <TextField
                  type={getEditType(editDialog.type)}
                  label={getEditLabel(editDialog.type)}
                  onKeyPress={(e) => onPassKeyPress(e)}
                  style={{
                    marginTop: 2,
                    minWidth: 160,
                    width: 160
                  }}
                  InputProps={{ readOnly: true }}
                  defaultValue={editDialog.originalData}
                  value={editDialog.originalData}
                  variant="outlined"
                />
                <TextField
                  type={getEditType(editDialog.type)}
                  label={getEditLabel2(editDialog.type)}
                  onKeyPress={(e) => onPassKeyPress(e)}
                  sx={{
                    marginTop: (theme) => theme.spacing(0.25),
                    minWidth: 260,
                    flex: 1
                  }}
                  defaultValue={editDialog.newData}
                  value={editDialog.newData}
                  onChange={(event) => {
                    const isUpdating = Array.isArray(productState.quantityUpdateIdfs) && productState.quantityUpdateIdfs.includes(editDialog.product?.id_fs)
                    if (isUpdating) return
                    setEditDialog({
                      ...editDialog,
                      newData: event.target.value,
                    })
                  }}
                  InputProps={{ readOnly: (Array.isArray(productState.quantityUpdateIdfs) && productState.quantityUpdateIdfs.includes(editDialog.product?.id_fs)) }}
                  disabled={Array.isArray(productState.quantityUpdateIdfs) && productState.quantityUpdateIdfs.includes(editDialog.product?.id_fs)}
                  variant="outlined"
                />
              </Box>
              :
              <>
                <TextField
                  type={getEditType(editDialog.type)}
                  label={getEditLabel(editDialog.type)}
                  onKeyPress={(e) => onPassKeyPress(e)}
                  style={{
                    marginTop: 2,
                    minWidth: 430
                  }}
                  fullWidth
                  defaultValue={editDialog.newData}
                  value={editDialog.newData}
                  onChange={(event) => {
                    setEditDialog({
                      ...editDialog,
                      newData: event.target.value,
                    })
                  }}
                  variant="outlined"
                />
                {
                  editDialog.type === EDIT_TYPE_PRODUCT_INFO ?
                    <TextField
                      label={getEditLabel2(editDialog.type)}
                      onKeyPress={(e) => onPassKeyPress(e)}
                      sx={{
                        marginTop: (theme) => theme.spacing(2),
                        minWidth: 440
                      }}
                      fullWidth
                      defaultValue={editDialog.newData2}
                      value={editDialog.newData2}
                      onChange={(event) => {
                        setEditDialog({
                          ...editDialog,
                          newData2: event.target.value,
                        })
                      }}
                      variant="outlined"
                    />
                    :
                    <div/>

                }
              </>
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditDialog({...editDialog, open: false})} color="secondary" sx={{ height: 40, px: 2.5, fontSize: 16, fontWeight: 'bold' }}>
            취소
          </Button>
          {
            editDialog.type === EDIT_TYPE_CENTER_STOCK ?
              <Select
                size={'small'}
                displayEmpty
                value={editDialog.req_type}
                onChange={(e) => {
                  const isUpdating = Array.isArray(productState.quantityUpdateIdfs) && productState.quantityUpdateIdfs.includes(editDialog.product?.id_fs)
                  if (isUpdating) return
                  const nextReqType = e.target.value
                  setEditDialog((prev) => ({
                    ...prev,
                    req_type: nextReqType,
                    etc_reason: (nextReqType === '기타' ? prev.etc_reason : ''),
                  }))
                }}
                disabled={(Array.isArray(productState.quantityUpdateIdfs) && productState.quantityUpdateIdfs.includes(editDialog.product?.id_fs))
                  || (Number(editDialog.newData) < 0)}
                sx={{ minWidth: 160, mr: 1 }}
              >
                <MenuItem value={''}>
                  <em>사유 선택</em>
                </MenuItem>
                <MenuItem value={'유통기한 지남'}>유통기한 지남</MenuItem>
                <MenuItem value={'제품 파손'}>제품 파손</MenuItem>
                <MenuItem value={'더 적음'}>더 적음</MenuItem>
                <MenuItem value={'기타'}>기타</MenuItem>
                <MenuItem value={'더 많음'}>더 많음</MenuItem>
              </Select>
              :
              <div/>
          }
          {
            (editDialog.type === EDIT_TYPE_CENTER_STOCK && editDialog.req_type === '기타') ?
              <TextField
                size={'small'}
                label={'기타 사유'}
                placeholder={'사유를 입력해 주세요'}
                value={editDialog.etc_reason}
                onChange={(e) => {
                  const isUpdating = Array.isArray(productState.quantityUpdateIdfs) && productState.quantityUpdateIdfs.includes(editDialog.product?.id_fs)
                  if (isUpdating) return
                  setEditDialog((prev) => ({
                    ...prev,
                    etc_reason: e.target.value,
                  }))
                }}
                disabled={(Array.isArray(productState.quantityUpdateIdfs) && productState.quantityUpdateIdfs.includes(editDialog.product?.id_fs))
                  || (Number(editDialog.newData) < 0)}
                sx={{ minWidth: 240, mr: 1 }}
              />
              :
              <div/>
          }
          <Button disabled={editDisabled()} autoFocus onClick={() => postEdit()} color="primary" sx={{ height: 40, px: 2.5, fontSize: 16, fontWeight: 'bold' }}>
            수정요청
          </Button>
        </DialogActions>
        {
          editDialog.type === EDIT_TYPE_CENTER_STOCK ?
            <Box sx={{
              display: 'flex',
              flexBasis: 5,
              fontSize: 12,
              pr: ((editDialog.history.length * STOCK_HISTORY_ROW_HEIGHT) > HISTORY_HEIGHT ? 1.5 : 0)
            }}>
              <Box sx={{flex: 1.5, textAlign: 'center'}}>총</Box>
              <Box sx={{flex: 1, textAlign: 'center'}}>네이버</Box>
              <Box sx={{flex: 1, textAlign: 'center'}}>쿠팡</Box>
              <Box sx={{flex: 4, textAlign: 'center'}}></Box>
            </Box>
            :
            <div/>
        }
        <DialogContent
          aria-multiline={true}
          sx={{
            minWidth: 280,
            maxHeight: HISTORY_HEIGHT,
            p: (theme) => theme.spacing(editDialog.type === EDIT_TYPE_CENTER_STOCK ? 0 : 1),
            // pl : (theme) => theme.spacing(1),
            // pr : (theme) => theme.spacing(1),
            // pt : (theme) => theme.spacing(1),
            // pb : (theme) => theme.spacing(1),
            // mb : (theme) => theme.spacing(0.5),
            borderWidth: (theme) => theme.spacing(0.1),
            borderColor: 'black',
            borderStyle: 'solid',
            // borderTopWidth : (theme) => theme.spacing(0.2),
            // borderTopColor : 'blue',
            // borderTopStyle : 'solid',
            // borderBottomWidth : (theme) => theme.spacing(0.2),
            // borderBottomColor : 'blue',
            // borderBottomStyle : 'solid',
          }}
        >

          {
            editDialog.history.length > 0 ?
              <List dense sx={{p: 0, m: 0}}>
                {editDialog.history.map((item, index) => (
                  <Fragment>
                    {historyRow(item, (index < editDialog.history.length - 1) ? editDialog.history[index + 1] : null, index)}
                    {editDialog.type === EDIT_TYPE_CENTER_STOCK ? <div/> : <Divider/>}
                  </Fragment>
                ))}
              </List>
              :
              <Box sx={{textAlign: 'center', p: 4}}>{"변경 이력 없음"}</Box>
          }

        </DialogContent>
      </Dialog>

      <Dialog
        open={storeBalanceDialog.open}
        onClose={() => {
          setStoreBalanceDialog({...storeBalanceDialog, open: false})
        }}
      >
        <DialogTitle id="storebalance-dialog-title">
          {"스토어 재고 수정"}
        </DialogTitle>
        <DialogContent>
          {storeBalanceDialog.product ? storeBalanceDialog.product.name : ''}
          {stockDetails(storeBalanceDialog.product, storeBalanceDialog.center_id)}
        </DialogContent>
        <DialogContent>
          <div style={{display: 'flex', flexDirection: 'row'}}>
            <div>
              {"스토어에서 재고를 "}
            </div>
            <div style={{color: 'red', fontWeight: 'bold', marginLeft: 3, marginRight: 1}}>
              {getStoreBalance(storeBalanceDialog.center_id, storeBalanceDialog.product)}
            </div>
            <div>
              {" 만큼 수정 해주세요"}
            </div>
          </div>
          <div style={{marginTop: 8, display: 'flex', flexDirection: 'row', alignItems: "center"}}>
            <Select
              variant={'outlined'}
              style={{minWidth: 120}}
              labelId="store-balance-select-label"
              id="demo-simple-select"
              value={storeBalanceDialog.store}
              onChange={(e) => {
                setStoreBalanceDialog({...storeBalanceDialog, store: e.target.value})
              }}
            >
              <MenuItem value={-1}>
              </MenuItem>
              <MenuItem value={1}>네이버에서 수정함 (모자란 수량은 쿠팡에서)</MenuItem>
              <MenuItem value={2}>쿠팡에서 수정함 (모자란 수량은 네이버에서)</MenuItem>
              <MenuItem value={0}>스토어 재고 수정 필요없음</MenuItem>
            </Select>
            {/*<div style={{marginLeft : 4}}>*/}
            {/*  {" 에서 수정함"}*/}
            {/*</div>*/}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setStoreBalanceDialog({...storeBalanceDialog, open: false})} color="secondary">
            취소
          </Button>
          <Button
            disabled={!Boolean(storeBalanceDialog.store >= 0)}
            onClick={() => fixStoreBalance(storeBalanceDialog.center_id)}
            color="primary">
            수정완료
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={dialog.open}
        onClose={() => {
          setDialog({...dialog, open: false})
        }}
      >
        <DialogTitle id="alert-dialog-title">{dialog.title}</DialogTitle>

        <DialogContent aria-multiline={true}>
          <div>{dialog.message}</div>
          {
            dialog.sub_messages.length > 0 ?
              <div style={{marginTop: 20}}>

                <List>
                  {dialog.sub_messages.map((item, index) => (
                    <div key={index}>{'- ' + item}</div>
                  ))}
                </List>

              </div>

              :
              <div/>
          }
        </DialogContent>

        
        <DialogActions>
          <Button onClick={() => {
            setDialog({...dialog, open: false})
          }} color="primary">
            닫기
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        id={'expiration-date-dialog'}
        fullWidth={true}
        maxWidth={true}
        open={expireDateDialog.open}
        onClose={() => {
          setExpireDateDialog({
            ...expireDateDialog,
            open: false,
          })
        }}
      >
        <DialogTitle>{expireDateDialog.product ? expireDateDialog.product.name : ''}</DialogTitle>
        <DialogContent
          aria-multiline={true}
        >

          <div
            style={{
              fontSize: 18,
              color: 'blue'
            }}
          >
            {`${getWarehouseNameFromId(expireDateDialog.centerId, warehouseState)}재고 유통기한 수정`}
          </div>

          {
            expireDateDialog.years.map((year) => {
              const now = new Date()
              now.setDate(1)
              now.setHours(0)
              now.setMinutes(0)
              now.setSeconds(0)
              now.setMilliseconds(0)

              return <Box sx={{display: 'flex', p: 1.3, fontSize: 20,}}>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: 22,
                  fontWeight: 'bold'
                }}>{year.getFullYear()}</Box>
                <Grid sx={{ml: 4,}} container spacing={1}>
                  {
                    [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((month) => {
                      const date = new Date(year.getFullYear(), month - 1, 1, 0, 0, 0)
                      const beforeMonth = date.getTime() < now.getTime()
                      // console.log('now ', now, ', date ', date)

                      return <Grid
                        onClick={() => {
                          if (beforeMonth) {
                            return
                          }
                          postExpireDate(expireDateDialog.index, expireDateDialog.product, expireDateDialog.centerId, date)
                        }}
                        item xs={1}>
                        <Box
                          sx={{
                            height: 44,
                            borderWidth: (theme) => theme.spacing(0.1),
                            borderColor: beforeMonth ? '#E0E0E0' : 'black',
                            color: beforeMonth ? '#E0E0E0' : 'black',
                            borderStyle: 'solid',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: 16,
                            // cursor : 'pointer',
                            cursor: beforeMonth ? 'auto' : 'pointer'
                          }}
                        >
                          {month}
                        </Box>
                      </Grid>
                    })
                  }

                </Grid>
              </Box>
            })
          }
        </DialogContent>

        <DialogActions sx={{alignItems: 'flex-start'}}>
          <Box sx={{flex: 1, display: 'flex', flexWrap: 'wrap', gap: 1, pr: 1}}>
            {
              expireDateDialog.listLoading ?
                <Box sx={{p: 0.5}}>로딩중...</Box>
                :
                (
                  (expireDateDialog.expireDateList || []).length > 0 ?
                    (expireDateDialog.expireDateList || []).map((item, i) => {
                      const dateStr = typeof item === 'string' ? item : (item && item.expire_date ? item.expire_date : '')
                      const label = dateStr ? moment(new Date(dateStr)).format('YYYY-MM') : '-'
                      const baseStyle = expireDateColorByDate(dateStr)
                      const hoverStyle = baseStyle.backgroundColor === 'transparent'
                        ? { backgroundColor: '#f5f5f5', color: 'black' }
                        : { backgroundColor: baseStyle.backgroundColor, color: baseStyle.color }
                      return (
                        <Button
                          key={i}
                          variant="outlined"
                          size="small"
                          sx={{
                            ...baseStyle,
                            borderColor: '#BDBDBD',
                            '&:hover': {
                              ...hoverStyle,
                              borderColor: '#9E9E9E',
                            },
                          }}
                          onClick={() => {}}
                          endIcon={<span onClick={(e)=>{ e.stopPropagation(); deleteExpireDate(expireDateDialog.index, expireDateDialog.product, expireDateDialog.centerId, dateStr) }} style={{fontWeight:'bold'}}>X</span>}
                        >
                          {label}
                        </Button>
                      )
                    })
                    :
                    <Box sx={{p: 0.5}}>등록된 유통기한이 없습니다.</Box>
                )
            }
          </Box>
          <Button
            onClick={() => setExpireDateDialog({...expireDateDialog, open: false})}
            color="secondary"
            sx={{
              backgroundColor: '#E3F2FD',
              color: '#0D47A1',
              '&:hover': { backgroundColor: '#BBDEFB' },
            }}
          >
            닫기
          </Button>
        </DialogActions>
        <div style={{
          outline: 2,
          outlineStyle: 'solid',
          outlineWidth: 1,
          outlineColor: 'black',
          maxHeight: 180,
          minHeight : 120,
          overflow: 'auto'
        }}>
          {
            expireDateDialog.history.length > 0 ?
              <List dense sx={{p: 0, m: 0}}>
                {expireDateDialog.history.map((row, index) => (
                  <div>
                    <div key={index} style={{paddingLeft: 12, paddingRight: 12, paddingTop: 14, paddingBottom: 14}}>
                    {`[${moment(new Date(row.create_date)).format('YY년MM월DD일 HH:mm')}] "${row.user_name}"이 유통기한 "${moment(new Date(row.event_target_value)).format('YY년MM월')}" ${
                      row.event_sub_type === 0
                        ? '을 추가함'
                        : row.event_sub_type === 9
                          ? '을 삭제함'
                          : ''
                    }`}
                    </div>
                    <Divider/>
                  </div>


                  // <ListItem key={index}>
                  //   <ListItemText
                  //     primary={'"' + row.user_name + '"이 유통기한을 "' + moment(new Date(row.event_target_value)).format('YY년MM월DD일 HH:mm') + '" 로 변경함'}
                  //     secondary={moment(new Date(row.create_date)).format('YY년MM월DD일 HH:mm')}/>
                  //   <Divider/>
                  // </ListItem>
                ))}
              </List>
              :
              <Box sx={{display: 'flex', textAlign: 'center', justifyContent: 'center'}}>{"변경 이력 없음"}</Box>
          }
        </div>

    </Dialog>
  <Backdrop sx={{
    zIndex: (theme) => theme.zIndex.drawer + 1,
    color: '#fff',
  }} open={imageShow.open} onClick={() => setImageShow({...imageShow, open: false})}>
    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
      <img src={changeImageURL(imageShow.url)} style={{width: 320, height: 320}}/>
      <div style={{marginTop: 10}}>{imageShow.title}</div>
    </div>
  </Backdrop>

  <Backdrop
    open={requesting}
    sx={{
      zIndex: (theme) => theme.zIndex.drawer + 1,
      color: '#fff',
    }}>
    <CircularProgress color="inherit"/>
  </Backdrop>
</Fragment>
)

}